import * as Yup from 'yup'
import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { useCallback } from 'react'
import { useSnackbar } from 'notistack'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Form, FormikProvider, useFormik } from 'formik'
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs.js'
import Page from 'src/components/Page.js'
// material
import { LoadingButton } from '@material-ui/lab'
import { Autocomplete, Checkbox, Chip, CircularProgress, FormControl, FormControlLabel, FormLabel, IconButton, InputAdornment, MenuItem, Radio, RadioGroup, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Avatar } from '@material-ui/core'
import { Icon } from '@iconify/react'
import eyeFill from '@iconify/icons-eva/eye-fill'
import eyeOffFill from '@iconify/icons-eva/eye-off-fill'
import { experimentalStyled as styled } from '@material-ui/core/styles';
import {
  Box,
  Button,
  Card,
  Grid,
  Stack,
  Switch,
  TextField,
  Typography,
  FormHelperText,
  Container,
} from '@material-ui/core'
// utils
import { fData } from '../../../utils/formatNumber'
import fakeRequest from '../../../utils/fakeRequest'
// routes
import { PATH_DASHBOARD } from '../../../routes/paths'
import { Link as RouterLink } from 'react-router-dom'
//
import Label from '../../Label'
import { UploadAvatar, UploadMultiFile } from '../../upload'
import axios from 'axios'
import { COMPANY_NAME, REST_API, REST_API_END_POINT } from 'src/constants/Defaultvalues'
import quickbookLogo from 'src/assets/quickbookLogo-removebg-preview.png'
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage'
import { storage } from 'src/firebase/firebase'
import is from 'date-fns/esm/locale/is/index.js'
import TagChip from '../contact_tag/TagChip'
import PhoneNumberField from 'src/components/PhoneNumberField'
import {parsePhoneNumberFromString} from 'libphonenumber-js'
import { supabase } from '../../../supabase/supabaseClient';
import { Delete, Refresh } from '@material-ui/icons'
import plusFill from '@iconify/icons-eva/plus-fill'
import copyFill from '@iconify/icons-eva/copy-fill'
import CopyToClipboard from 'react-copy-to-clipboard'
import countries from '../user/countries'
import {
  findDefaultUsCountry,
  getPostalCodeLabel,
  requiresStateDropdown,
  requiresStateProvinceText,
} from 'src/utils/clientAddress'
// ----------------------------------------------------------------------

// Alphanumeric comparison helper function (natural sort)
function alphanumericCompare(str1, str2) {
  const normalize = (str) => {
    if (str === null || str === undefined) return '';
    // Strip leading and trailing quotes before comparison
    let normalized = str.toString().trim();
    // Remove leading and trailing quotes (both single and double)
    normalized = normalized.replace(/^["']+|["']+$/g, '');
    return normalized;
  };

  const a = normalize(str1);
  const b = normalize(str2);

  // Split into parts: strings and numbers
  const partsA = a.match(/(\d+|\D+)/g) || [];
  const partsB = b.match(/(\d+|\D+)/g) || [];

  // Compare each part
  const minLength = Math.min(partsA.length, partsB.length);
  for (let i = 0; i < minLength; i++) {
    const partA = partsA[i];
    const partB = partsB[i];

    // If both parts are numbers, compare numerically
    if (/^\d+$/.test(partA) && /^\d+$/.test(partB)) {
      const numA = parseInt(partA, 10);
      const numB = parseInt(partB, 10);
      if (numA !== numB) {
        return numA - numB;
      }
    } else {
      // Otherwise, compare as strings (case-insensitive)
      const strCompare = partA.localeCompare(partB, undefined, { sensitivity: 'base' });
      if (strCompare !== 0) {
        return strCompare;
      }
    }
  }

  // If all parts are equal, shorter string comes first
  return partsA.length - partsB.length;
}

const getPaymentTermLabel = (option) =>
  // option?.name ? `${option?.name} ( ${option?.billing_type} % )` : '';
  option?.name ? `${option?.name}` : '';

const renderPaymentTermOption = (props, data) => (
  <MenuItem {...props}>
    {data?.quickbookId ? (
      <img src={quickbookLogo} width="40px" height="20px" style={{ marginRight: 8 }} alt="QuickBooks" />
    ) : null}
    {getPaymentTermLabel(data)}
  </MenuItem>
);

const renderPaymentTermInput = ({ params, value, error, helperText, placeholder }) => (
  <TextField
    {...params}
    label="Payment Terms"
    placeholder={placeholder}
    error={error}
    helperText={helperText}
    InputProps={{
      ...params.InputProps,
      startAdornment: (
        <>
          {/* {value?.quickbookId ? ( */}
            <InputAdornment position="start">
              <Avatar src={quickbookLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover" }} />
            </InputAdornment>
          {/* ) : null} */}
          {params.InputProps.startAdornment}
        </>
      ),
    }}
  />
);

function isValidPhoneForCountry(phoneNumber, countryCode) {
  const nationalNumber = `${phoneNumber || ''}`.trim();
  const dialCode = `${countryCode || ''}`.replace(/^\+/, '').trim();

  if (!nationalNumber) {
    return false;
  }

  const phoneToParse = dialCode
    ? `+${dialCode}${nationalNumber}`
    : nationalNumber.startsWith('+')
      ? nationalNumber
      : `+${nationalNumber}`;

  const parsedPhone = parsePhoneNumberFromString(phoneToParse);
  return parsedPhone ? parsedPhone.isValid() : false;
}

function isReasonablePhoneInput(phoneNumber) {
  if (!phoneNumber) return false;
  const digits = String(phoneNumber).replace(/\D/g, '');
  return digits.length >= 10 && digits.length <= 15;
}

function restrictVendorPhoneInput(event) {
  event.target.value = event.target.value.replace(/\D/g, '').slice(0, 15);
}

function cleanTextValue(value) {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') return value.trim();
  if (typeof value === 'number') return String(value).trim();
  return '';
}

UserNewForm.propTypes = {
  isEdit: PropTypes.bool,
  currentUser: PropTypes.object,
}

const LabelStyle = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtitle2,
  // color: theme.palette.text.secondary,
  textAlign:'center',
  marginBottom: theme.spacing(1)
}));
const LabelStyleNew = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtitle2,
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(1)
}));
const documentUploadAccept = [
  'image/*',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/csv',
  'text/plain',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.csv',
  '.txt'
].join(',');
export default function UserNewForm({popupOn,team, setRenderCards, clientType,  closeView, renderCards, editClientId, setViewAccount}) {
  console.log('clientType===============', clientType)
  //------------------------------------------------------------------------------------------
  //get user logged in data from local storage
  const user = localStorage.getItem('user')
  const userData = JSON.parse(user)
  const userType = userData.user_type
  const isClient = userData?.isClient

  //------------------------------------------------------------------------------------------

  /*******************************************************************************************/
  const location = useLocation()
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const clientId = useParams()
  const searchParams = new URLSearchParams(location.search)
  const id = popupOn? editClientId : clientId.id
  // console.log(clientId.id, '%%%%%%%%%%%%%%%%')
  const editId = popupOn ? editClientId : parseInt(id)
  const isAdmin = popupOn ? team : clientId.isAdmin === 'true'
  // const [progress,setProgress] = useState(0)
  const [editDetails, setEditDetails] = useState([])
  const [stateData, setStateData] = useState([])
  const [countryData, setCountryData] = useState([])
  const [roleData, setRoleData] = useState([])
  const [departmentData, setDepartmentData] = useState([])
  const [servicesData, setServicesData] = useState([])
  const [partnerType,setPartnerType] =useState(null)
  const [ranks,setRanks] =useState(null)
  const [contactTags,setContactTags] = useState([])
  const [workFlow,setWorkFlow] =useState(null)
  const [selectedFile, setSelectedFile] = useState(null)
  const [customerTypeData,setCustomerTypeData] = useState([])
  const [uploadFiles, setUploadFiles] = useState([]); // Store uploaded files
  const [insuranceFiles, setInsuranceFiles] = useState([]);
  const [otherFormFiles, setOtherFormFiles] = useState([]);
  const [isUploadingFiles, setIsUploadingFiles] = useState(false); // Uploading state
  const [progress, setProgress] = useState(null); // Progress state
  const [additionalEmails,setAdditionalEmails] = useState([])
  const [newPassError, setNewPassError] = useState('');
  const [confirmPassError, setConfirmPassError] = useState('');
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const credentialsNeedCheck = (values) =>
    Boolean(
      newPassword ||
      (values.email || '') !== (editDetails.email || '') ||
      (values.phoneNumber || '') !== (editDetails.phone || ''),
    );
  const checkPasswordDuplicate = async (email, phone, password, userId) => {
    if (!userId || (!email?.trim() && !phone?.trim())) return null;
    try {
      const response = await axios.post(
        `${REST_API_END_POINT}teams/check-email-password-exist`,
        { email, phone, password: password || undefined, userId },
      );
      return response.data?.type ? response.data : null;
    } catch (error) {
      console.error('Error checking credential duplicate:', error);
      return null;
    }
  };
  const blockIfCredentialDuplicate = async (values, setFieldError, setSubmitting) => {
    if (!credentialsNeedCheck(values) || !editDetails?.user_id) return false;
    const duplicate = await checkPasswordDuplicate(
      values.email,
      values.phoneNumber,
      newPassword,
      editDetails.user_id,
    );
    if (!duplicate?.message) return false;
    if (duplicate.type === 'email') {
      setFieldError('email', duplicate.message);
    }
    if (duplicate.type === 'phone') {
      setFieldError('phoneNumber', duplicate.message);
    }
    if (newPassword) {
      setNewPassError(duplicate.message);
    }
    enqueueSnackbar(duplicate.message, { variant: 'error' });
    setSubmitting(false);
    return true;
  };
  const [quickbookSandboxExistingCustomers,setQuickbookSandboxExistingCustomers] = useState([])
  const [uniqueName,setUniqueName] = useState(true)
  const [isNewVendor, setNewVendor] = useState(false) // false = New Vendor/Customer, true = Existing
  const [vendorsOrCustomers, setVendorsOrCustomers] = useState([])
  const [searchQuery, setSearchQuery] = useState('')
  const [loadingVendorsOrCustomers, setLoadingVendorsOrCustomers] = useState(false)
  const debounceRef = useRef(null)
  const [partnerQbIds, setPartnerQbIds] = useState([]);
  const [loading,setLoading] = useState(false)
  const [userRoles, setUserRoles] = useState([]);
  const [avalaraTaxType, setAvalaraTaxType] = useState(null); // Default value can be '1' (Taxable Client)
  const [teamMembers, setTeamMembers] = useState([]);
  const [userPin, setUserPin] = useState('');
  const [isUpdatingPin, setIsUpdatingPin] = useState(false);
  const explodedPermissions = userData?.exploded_permissions
  const hasSwitchUserPinPermission = explodedPermissions?.some(permission => ['Switch User With Pin'].includes(permission)) ? true : false

  const [openBackConfirm, setOpenBackConfirm] = useState(false);

  const fetchStatesByCountry = (countryId) => {
    if (!countryId) {
      setStateData([]);
      return;
    }
    axios.post(`${REST_API_END_POINT}clients/get-all-states`, { countryId })
      .then((res) => {
        const sortedStates = [...(res.data.data || [])].sort((a, b) =>
          alphanumericCompare(a?.name || '', b?.name || '')
        );
        setStateData(sortedStates);
      })
      .catch((err) => {
        console.error('Error fetching states:', err);
        setStateData([]);
      });
  };

  const fetchTeamMembers = async () => {
    try {
      const response = await axios.post(`${REST_API_END_POINT}teams/get-all-sales-reps-data`, {
        usersId: userData.user_id,
        usersType: userData.user_type,
        isClient: false,
        page: 1,
        rowsPerPage: 1000, // Fetch all team members for autocomplete
        search: ''
      });
      if (response.data.status === 1) {
        const members = response.data.team_members.data;
        const updatedMembers = members.map(member => {
          if (member.id === userData.user_id || member.user_id === userData.user_id) {
            // return { ...member, first_name: 'Myself', last_name: '' };
            return { ...member, first_name: userData.first_name || '', last_name: userData.last_name || '' };
          }
          return member;
        });
        // Sort team members alphanumerically by first_name + last_name
        const sortedMembers = [...updatedMembers].sort((a, b) => {
          const nameA = `${a?.first_name || ''} ${a?.last_name || ''}`.trim();
          const nameB = `${b?.first_name || ''} ${b?.last_name || ''}`.trim();
          return alphanumericCompare(nameA, nameB);
        });
        setTeamMembers(sortedMembers);
      } else {
        setTeamMembers([]);
      }
    } catch (error) {
      console.error('Error fetching team members:', error);
    }
  };

  console.log(teamMembers,'--------teamMembers')
  useEffect(() => {
    fetchTeamMembers();
  }, []);

  // Browser back button interception for auto-save
  useEffect(() => {
    const handlePopState = (event) => {
      event.preventDefault();
      setOpenBackConfirm(true);
      // Push a dummy state to prevent immediate navigation
      window.history.pushState(null, '', window.location.href);
    };

    // Push initial state for back button interception
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);
  let defaultDepartment = null
  let defaultState = null
  let defaultRemitToState = null
  let defaultRemitToCountry = null
  let defaultCountry = null
  if (editDetails?.country_id && countryData?.length) {
    defaultCountry = countryData.find((country) => Number(country.id) === Number(editDetails.country_id)) || null
  }
  if (!defaultCountry && countryData?.length) {
    defaultCountry = findDefaultUsCountry(countryData)
  }
  let defaultRole = null
  let defaultParnterType =null
  let defaultRank =null
  let defaultTags = []

      const fetchUserPin = async (userId) => {
        try {
          if (userId) {
            const result = await axios.post(`${REST_API_END_POINT}get-user-pin`, { userId });
            if (result.data.status === 1) {
              setUserPin(result.data.pin || '');
            }
          }
        } catch (error) {
          console.error('Error fetching PIN:', error);
        }
      };

      const fetchData = async () => {
      if (isAdmin) {
        const response = await axios.post(`${REST_API_END_POINT}teams/get-team-by-id?id=${editId}`,)
        if (response.data.status == 1) {
          setEditDetails(response.data.teamData)
          // Fetch user PIN
          if (response.data.teamData?.user_id) {
            fetchUserPin(response.data.teamData.user_id);
          }
          // Sort states alphanumerically by name
          const sortedStates = [...(response.data.states || [])].sort((a, b) => 
            alphanumericCompare(a?.name || '', b?.name || '')
          );
          setStateData(sortedStates)
          if(userData.user_type === 3 || isClient){ 
            let filteredUserRole = response.data.userRoles.filter(role =>role.added_by == userData.user_id)
            console.log(userData.user_type,'filteredUserRole',filteredUserRole)
            // Sort user roles alphanumerically by name
            // const sortedRoles = [...filteredUserRole].sort((a, b) => 
            //   alphanumericCompare(a?.name || '', b?.name || '')
            // );
                     const sortedRoles = [...filteredUserRole]
  .filter((role) => {
    // userType 1 can see all roles
    if (Number(userData?.user_type) === 1) return true;

    // other users cannot see Owner role or role id 1
    return Number(role?.id) !== 1 && role?.name?.toLowerCase() !== 'owner' &&  role?.name?.toLowerCase() !== 'Super Administrator'.toLowerCase();
  })
  .sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''));
            setRoleData(sortedRoles);
  
         }else{
            let filteredUserRole = response.data.userRoles.filter(role =>role.is_added_by_client == 0)
            // Sort user roles alphanumerically by name
            // const sortedRoles = [...filteredUserRole].sort((a, b) => 
            //   alphanumericCompare(a?.name || '', b?.name || '')
            // );
                const sortedRoles = [...filteredUserRole]
  .filter((role) => {
    // userType 1 can see all roles
    if (Number(userData?.user_type) === 1) return true;

    // other users cannot see Owner role or role id 1
    return Number(role?.id) !== 1 && role?.name?.toLowerCase() !== 'owner' &&  role?.name?.toLowerCase() !== 'Super Administrator'.toLowerCase();
  })
  .sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''));
            setRoleData(sortedRoles);
            setRoleData(sortedRoles)
         }
          // Sort departments alphanumerically by name
          const sortedDepartments = [...(response.data.departments || [])].sort((a, b) => 
            alphanumericCompare(a?.name || '', b?.name || '')
          );
          setDepartmentData(sortedDepartments)
          // Sort services alphanumerically by name
          const sortedServices = [...(response.data.services || [])].sort((a, b) => 
            alphanumericCompare(a?.name || '', b?.name || '')
          );
          setServicesData(sortedServices)
          // Sort contact tags alphanumerically by name
          const sortedContactTags = [...(response.data.contact_tags.data || [])].sort((a, b) => 
            alphanumericCompare(a?.name || '', b?.name || '')
          );
          setContactTags(sortedContactTags)
        } else {
          enqueueSnackbar('No matching data found', { variant: 'error' })
          navigate(PATH_DASHBOARD.callCenter.teams)
        }
      }else{
      try{
        setLoading(true)
          const explodedPermissions =userData?.exploded_permissions
        let hasPermission = explodedPermissions?.some(permission => ['Inviting clients','Edit clients','Delete clients'].includes(permission)) ? true : false
        if(!editId || editId==""){
          console.log('editId not available')
          return;
        }
        const data ={id:editId,userId:userData.user_id,userType:userData.user_type,hasPermission:hasPermission}
        const res = await axios.post(`${REST_API_END_POINT}clients/fetch-client-by-id`,data)
        setAvalaraTaxType(res.data.client.avalaraTaxType)
        setEditDetails(res.data.client)
        setAdditionalEmails(res.data.additionalEmails || [])
        // Fetch user PIN after editDetails is set
        if (res.data.client?.user_id) {
          try{
          const pinResult = await axios.post(`${REST_API_END_POINT}get-user-pin`, { userId: res.data.client.user_id });
          if (pinResult.data.status === 1) {
            setUserPin(pinResult.data.pin || '');
          }
        }catch(error){
          console.error('Error fetching PIN:', error);
        }
        }
        if (res.data.clientTaxExemptAttachments) {
          const attachmentFiles = res.data.clientTaxExemptAttachments.map(attachment => ({
            url: attachment.url,
            file_type: attachment.file_type,
            extension: attachment.extension,
            size: attachment.size,
            attachment_type: attachment.attachment_type || 'tax_exempt'
          }));
          setUploadFiles(attachmentFiles.filter(file => file.attachment_type === 'tax_exempt'));
          setInsuranceFiles(attachmentFiles.filter(file => file.attachment_type === 'insurance'));
          setOtherFormFiles(attachmentFiles.filter(file => file.attachment_type === 'other_form'));
        }
         if (editDetails?.user_type) {
        const d_userRole = res.data.client.find((d) => d.id === editDetails.user_type)
        if (d_userRole) {
          defaultRole = d_userRole
        }
      } else {
        defaultRole = null
      }
        const sortedCountries = [...(res.data.countries || [])].sort((a, b) =>
          alphanumericCompare(a?.name || '', b?.name || '')
        );
        setCountryData(sortedCountries)
        const clientCountryId = res.data.client?.country_id
          || findDefaultUsCountry(sortedCountries)?.id;
        if (clientCountryId) {
          fetchStatesByCountry(clientCountryId);
        }
        // Sort ranks alphanumerically by name
        const sortedRanks = [...(res.data.ranks || [])].sort((a, b) => 
          alphanumericCompare(a?.name || '', b?.name || '')
        );
        setRanks(sortedRanks)
        setWorkFlow(res.data.workflows)
        // Sort partner types alphanumerically by name
        const sortedPartnerTypes = [...(res.data.partnerTypes || [])].sort((a, b) => 
          alphanumericCompare(a?.name || '', b?.name || '')
        );
        setPartnerType(sortedPartnerTypes)
        // Sort contact tags alphanumerically by name
        const sortedContactTags = [...(res.data.contactTags.data || [])].sort((a, b) => 
          alphanumericCompare(a?.name || '', b?.name || '')
        );
        setContactTags(sortedContactTags)
        // Sort customer types alphanumerically by name
        const sortedCustomerTypes = [...(res.data.customerTypes || [])].sort((a, b) => 
          alphanumericCompare(a?.name || '', b?.name || '')
        );
        setCustomerTypeData(sortedCustomerTypes)
      }catch{
        setEditDetails([])
        setStateData([])
        setCountryData([])
        setRanks([])
        setWorkFlow([])
        setPartnerType(null)
        setContactTags([])
        setCustomerTypeData([])
      }finally{
        setLoading(false)
      }
      }
    }

      const fetchAllUserRole = async()=>{
        try {
        const response = await axios.post(`${REST_API_END_POINT}teams/get-user-roles`,{isClientUserRole:true});
          // Sort user roles alphanumerically by name
          const sortedUserRoles = [...(response?.data?.result || [])].sort((a, b) => 
            alphanumericCompare(a?.name || '', b?.name || '')
          );
          setUserRoles(sortedUserRoles);
        } catch (error) {
          console.log("error",error)
        }
      }

  useEffect(() => {
    fetchAllUserRole()
    fetchData();
    // fetchQuickbookCustomerVendorData()
  }, [])

  const getAllPartnerQbIds = async () => {
    try {
      const isVendorFlag = (popupOn ? clientType === 'vendor' : clientId?.type === 'vendor') ? 1 : 0;
      const response = await axios.post(
        `${REST_API}webservice/clients/get-all-partner-qb`,
        { isVendor: isVendorFlag }
      );
      if (response.data.status === 1) {
        const result = response?.data?.result;
        setPartnerQbIds(Array.isArray(result) ? result : []);
      } else {
        setPartnerQbIds([]);
      }
    } catch (error) {
      console.error('Error fetching partner QB Ids:', error);
      setPartnerQbIds([]);
    }
  };

  const fetchQuickbookCustomerVendorData = async()=>{
    if(popupOn ? clientType === 'client' : clientId.type === 'client'){
   await axios.get(`${REST_API}webservice/clients/get-customers-quickbook-sandbox`)
      .then(res =>{
       console.log("quickbook sandbox existing customers",res.data.result.QueryResponse.Customer)
       setQuickbookSandboxExistingCustomers(res.data.result.QueryResponse.Customer)
      }).catch(err=>console.log(err))
     }else if(popupOn ? clientType === 'vendor' : clientId.type === 'vendor'){
     await axios.get(`${REST_API}webservice/vendor/get-vendors-quickbook-sandbox`)
       .then(res =>{
        console.log("quickbook sandbox existing vendors",res.data.result.QueryResponse.Vendor)
        setQuickbookSandboxExistingCustomers(res.data.result.QueryResponse.Vendor)
       }).catch(err=>console.log(err))
     }
  }

  const fetchQuickbookCustomers = async (query) => {
    let url = '';
    if (popupOn ? clientType === 'client' : clientId?.type === 'client') {
      url = `${REST_API}webservice/clients/get-customers-quickbook-sandbox`;
    } else if (popupOn ? clientType === 'vendor' : clientId?.type === 'vendor') {
      url = `${REST_API}webservice/vendor/get-vendors-quickbook-sandbox`;
    }
    if (!url) {
      setVendorsOrCustomers([]);
      return;
    }
    try {
      setLoadingVendorsOrCustomers(true);
      const response = await axios.post(url, { search: query ?? '' }, { headers: { 'Content-Type': 'application/json' } });
      if (response.data.status === 1) {
        const result = response?.data?.result;
        setVendorsOrCustomers(Array.isArray(result) ? result : []);
      }
    } catch {
      setVendorsOrCustomers([]);
    } finally {
      setLoadingVendorsOrCustomers(false);
    }
  };

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      fetchQuickbookCustomers(searchQuery);
    }, 400);
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [searchQuery]);

  useEffect(() => {
    fetchQuickbookCustomers();
    getAllPartnerQbIds();
  }, []);

  // When editing: if partnerQbId exists, they selected Existing; otherwise New (manual entry)
  useEffect(() => {
    if (editDetails?.partnerQbId) {
      setNewVendor(false); // Existing
    } else if (editDetails && Object.keys(editDetails).length > 0) {
      setNewVendor(true); // New (no QB id = manually entered)
    }
  }, [editDetails?.partnerQbId, editDetails]);


let defaultServicesArray=null
  // console.log(contactTags,'--------contactTags------')
  // console.log(editDetails,'--------editDetails------')
    if (isAdmin) {
      if (editDetails.department_id) {
        const d_department = departmentData.find((d) => d.id === editDetails.department_id,)
        if (d_department) {
          defaultDepartment = d_department
        }
      } else {
        defaultDepartment = null
      }
      if (editDetails.services) {
        // const d_services = servicesData.find((d) => d.id === editDetails.services,)
        const serviceIds = (editDetails.services.includes(',')) ? (editDetails.services.split(',').map((id) => parseInt(id))) : [parseInt(editDetails.services)];
        defaultServicesArray = serviceIds.map((serviceId) => servicesData?.find((d) => d.id === serviceId) || null);
      }

      if (editDetails?.state_id) {
        const d_state = stateData?.find((d) => d?.id === editDetails?.state_id)
        if (d_state) {
          defaultState = d_state
        }
      } else {
        defaultState = null
      }
      if (editDetails?.user_type && !isClient) {
        const d_userRole = roleData.find((d) => d.id === editDetails.user_type)
        if (d_userRole) {
          defaultRole = d_userRole
        }
      }else if(isClient){
          const d_userRole = userRoles.find((d) => d.id === editDetails.user_type)
        if (d_userRole) {
          defaultRole = d_userRole
        }
      } else {
        defaultRole = null
      }
      if(editDetails?.contact_tags){
        let tag = editDetails?.contact_tags.split(',').map(Number);
        let def_tag = contactTags?.filter(skill => tag.includes(skill.id));
        if(def_tag){
          defaultTags=def_tag
        }
      }
      else{
        defaultTags=[]
      }
    }else{
       if (editDetails?.user_type) {
        const d_userRole = userRoles.find((d) => d.id === editDetails.user_type)
        if (d_userRole) {
          defaultRole = d_userRole
        }
      } else {
        defaultRole = null
      }

      if (editDetails?.state_id) {
        const d_state = stateData?.find((d) => d?.id === editDetails?.state_id)
        if (d_state) {
          defaultState = d_state
        }
      } else {
        defaultState = null
      }
      if(editDetails.partner_type){
        const def_part_Type = partnerType?.find((d)=>
           d.id === editDetails?.partner_type
        )
       
        if(def_part_Type){
          defaultParnterType=def_part_Type
        }
      }
      else{
        defaultParnterType = null
      }
      if(editDetails.rank_id){
        const def_rank = ranks?.find((def)=>def.id == editDetails?.rank_id)
        
        if(def_rank){
          defaultRank=def_rank
        }
      }
      else{
        defaultRank=null
      }
      if(editDetails?.contact_tags){
        let tag = editDetails?.contact_tags?.split(',')?.map(Number);
        let def_tag = contactTags?.filter(skill => tag.includes(skill.id));
        if(def_tag){
          defaultTags=def_tag
        }
      }
      else{
        defaultTags=[]
      }
      if(editDetails?.remit_to_state_id){
        const d_remit_state = stateData?.find((d) => d?.id === editDetails?.remit_to_state_id)
        if (d_remit_state) {
          defaultRemitToState = d_remit_state
        }
      } else {
        defaultRemitToState = null
      }
      if(editDetails?.remit_to_country){
        const d_remit_country = countries?.find((d) => d?.code === editDetails?.remit_to_country)
        if (d_remit_country) {
          defaultRemitToCountry = d_remit_country
        }
      } else {
        defaultRemitToCountry = null
      }
    }


  const NewUserSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    // contact_name: !isAdmin && (popupOn ? clientType === 'client' : clientId.type === 'client') ? Yup.string().required('Contact Name is required') : Yup.string(),
    email:!isAdmin && Yup.string().required('Email is required').email(),
    // profile_pic:  Yup.mixed().required('Upload a profile photo'),
    // avatarUrl:  Yup.mixed().required('Upload Cover Image'),
    // phoneNumber:!isAdmin && Yup.number().typeError('Please enter a valid phone number').required('Phone number is required'),
    // forward_no:userType !==3 && Yup.number().typeError('Please enter a valid phone number'),
    phoneNumber: isAdmin
      ? Yup.string().nullable().test(
          'is-valid-phone-number',
          'Invalid phone number for selected country',
          function (value) {
            if (!value) {
              return true;
            }

            return isValidPhoneForCountry(value, this.parent.phone_country_code);
          },
        )
      : Yup.string()
          .required('Phone number is required')
          .test(
            'is-valid-phone-number',
            'Invalid phone number for selected country',
            function (value) {
              return isValidPhoneForCountry(value, this.parent.phone_country_code);
            },
          ),
    forward_no: userType !==3
      ? Yup.string().nullable().test(
          'is-valid-forward-number',
          'Invalid forward number for selected country',
          function (value) {
            if (!value) {
              return true;
            }

            return isValidPhoneForCountry(value, this.parent.forward_country_code);
          },
        )
      : Yup.mixed(),
    phone_extension:
      (isAdmin || (popupOn ? (clientType === 'client' || clientType === 'vendor') : (clientId.type === 'client' || clientId.type === 'vendor')))
        ? Yup.number()
            .typeError('Please enter a valid phone extension')
            .min(0, 'Phone extension cannot be negative')
            .nullable()
        : Yup.mixed().nullable(),
    // hourlyRate:userType !==3 && Yup.number().typeError('Please enter a valid amount'),
    state: clientType === 'vendor'
      ? Yup.object().nullable()
      : (!isAdmin && userType !== 3 && Yup.object().nullable().test('state-required', 'State is required', function(value) {
          if (clientType !== 'client') return true;
          if (!requiresStateDropdown(this.parent.country, stateData)) return true;
          return Boolean(value);
        })),
    country: (clientType === 'client' && !isAdmin)
      ? Yup.object().nullable().required('Country is required')
      : Yup.object().nullable(),
    stateProvince: (clientType === 'client' && !isAdmin)
      ? Yup.string().trim().test('province-required', 'State/Province is required', function(value) {
          if (!requiresStateProvinceText(this.parent.country, stateData)) return true;
          return Boolean(value && value.trim());
        })
      : Yup.string().trim(),
    salesRepNames: (clientType === 'client') && Yup.array().min(1, 'Sales Representative is required').required('Sales Representative is required'),
    address: !isAdmin ? Yup.string().trim().min(1, 'Address cannot be empty') : Yup.string().trim(),
    city: !isAdmin ? Yup.string().trim().min(1, 'City cannot be empty') : Yup.string().trim(),
    zipcode: !isAdmin ? Yup.string().trim().min(1, 'Zip Code cannot be empty') : Yup.string().trim(),
    remitToAddress: (!isAdmin && (popupOn ? clientType === 'vendor' : clientId.type === 'vendor')) ? Yup.string().trim().test('remit-required', 'Remit-To Address is required', function(value) { const { remitToCity, remitToZipCode, remitToState } = this.parent; if ((value || remitToCity || remitToZipCode || remitToState) && !value) return false; return true; }) : Yup.string().trim(),
    remitToCity: (!isAdmin && (popupOn ? clientType === 'vendor' : clientId.type === 'vendor')) ? Yup.string().trim().test('remit-required', 'Remit-To City is required', function(value) { const { remitToAddress, remitToZipCode, remitToState } = this.parent; if ((remitToAddress || value || remitToZipCode || remitToState) && !value) return false; return true; }) : Yup.string().trim(),
    remitToZipCode: (!isAdmin && (popupOn ? clientType === 'vendor' : clientId.type === 'vendor')) ? Yup.string().trim().test('remit-required', 'Remit-To Zip Code is required', function(value) { const { remitToAddress, remitToCity, remitToState } = this.parent; if ((remitToAddress || remitToCity || value || remitToState) && !value) return false; return true; }) : Yup.string().trim(),
    remitToState: (!isAdmin && (popupOn ? clientType === 'vendor' : clientId.type === 'vendor')) ? Yup.object().nullable().test('remit-required', 'Remit-To State is required', function(value) { const { remitToAddress, remitToCity, remitToZipCode } = this.parent; if ((remitToAddress || remitToCity || remitToZipCode || value) && !value) return false; return true; }) : Yup.object().nullable(),
    remitToCountry: Yup.object().nullable(),
    vendorOrderEmail: Yup.string().trim().email('Invalid email'),
    vendorAccountingEmail: Yup.string().trim().email('Invalid email'),
    vendorWebsite: Yup.string()
      .trim()
      .test('valid-website', 'Please enter a valid website URL', (value) => {
        if (!value) return true;
        const raw = String(value).trim();
        try {
          // eslint-disable-next-line no-new
          new URL(raw.includes('://') ? raw : `https://${raw}`);
          return true;
        } catch {
          return false;
        }
      }),
    vendorTelephoneNumber: Yup.string().test('valid-vendor-phone', 'Please enter a valid vendor phone number', (value) => {
      if (!value) return true;
      return isReasonablePhoneInput(value);
    }),
    vendorRepCellNumber: Yup.string().test('valid-rep-cell', 'Please enter a valid rep cell number', (value) => {
      if (!value) return true;
      return isReasonablePhoneInput(value);
    }),
    vendorAccountingPhoneNumber: Yup.string().test('valid-accounting-phone', 'Please enter a valid accounting phone number', (value) => {
      if (!value) return true;
      return isReasonablePhoneInput(value);
    }),
    vendorNotes: Yup.string()
  .max(100, 'Notes cannot exceed 100 characters')
  .nullable(),
    vendorPaymentTerms: Yup.object().nullable(),
    // uploadFiles: (avalaraTaxType && avalaraTaxType === '1') 
    // ? Yup.array().notRequired() 
    // : Yup.array().min(1, 'Please upload tax-exempt documents').required('Please upload tax-exempt documents'),       
  })
  
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: isAdmin && editDetails.first_name || editDetails.name || '',
      contact_name: !isAdmin && editDetails.contact_name || '',
      lastName: isAdmin && editDetails.last_name || '',
      email: editDetails.email || '',
      phoneNumber: editDetails.phone || '',
      phone_country_code: editDetails.phone_country_code || '1',
      forward_no: editDetails.forward_no || '',
      forward_country_code: editDetails.forward_country_code || '',
      hourlyRate: editDetails.hourly_rate || '',
      role: defaultRole  || null,
      department: defaultDepartment || null,
      service: defaultServicesArray || [],
      state: defaultState || null,
      country: !isAdmin && ((popupOn ? clientType === 'client' : clientId.type === 'client') ? defaultCountry : null),
      stateProvince: !isAdmin && editDetails?.state_province || '',
      zipcode:!isAdmin && editDetails.zip_code ||'',
      // avatarUrl: isAdmin && `${REST_API}build/images/team_members/${editDetails.profile_pic}` || null,
      avatarUrl: isAdmin && ((editDetails?.company_logo !== "default_logo.png") ? editDetails?.company_logo : '') || editDetails?.thumbnail || '',  // '/static/mock-images/avatars/avatar_default1.jpg'
      address:  !isAdmin && editDetails.address|| '',
      city: editDetails.city|| '',
      rank:!isAdmin && defaultRank||null,
      contact_tags: defaultTags||null,
      partnerType:!isAdmin && defaultParnterType||'',
      fax: !isAdmin && editDetails.fax_number||'',
      phone_extension:
        (isAdmin || (popupOn ? (clientType === 'client' || clientType === 'vendor') : (clientId.type === 'client' || clientId.type === 'vendor')))
          ? editDetails.phone_extension || null
          : null,
      profile_pic: editDetails?.profile_pic !== 'avatar.jpg' && editDetails?.profile_pic || '', //avatar.jpg
      quickbookCustomerName:editDetails?.quickbookCustomerName || '',
      existingQuickbookCustomerName:editDetails?.quickbookCustomerName || '',
      isSyncWithQuickbooks: editDetails?.isSyncWithQuickbooks===1? true:false || false,
      customerType:editDetails? customerTypeData?.find(val => editDetails?.customerTypeId ==val.id) : null,
      partnerQbId: editDetails?.partnerQbId ? editDetails?.partnerQbId : null || null,
      // role:defaultRole || editDetails? userRoles.find(val=> val.id == editDetails.user_type): null
      avalaraTaxType:(!isAdmin && editDetails?.avalaraTaxType) ? String(editDetails?.avalaraTaxType) : '1' || '1',
      user_id:editDetails?.user_id || null,
      uploadFiles,
      insuranceFiles,
      otherFormFiles,
      additionalEmails: editDetails.additionalEmails || [],
      // salesRepNames: editDetails?.sales_rep_full_names ? editDetails?.sales_rep_full_names.split(',').map(name => ({ name: name.trim() })) : [],
      salesRepNames: editDetails?.sales_rep_names && editDetails.sales_rep_names.length > 0
        ? editDetails.sales_rep_names.split(',').map(id => {
            const matched = teamMembers.find(member => member.id === Number(id));
            return matched ? { id: matched.id, name: `${matched.first_name} ${matched.last_name}` } : null;
          }).filter(Boolean)
        : [],
      remitToAddress: !isAdmin && editDetails?.remit_to_address || '',
      remitToCity: !isAdmin && editDetails?.remit_to_city || '',
      remitToZipCode: !isAdmin && editDetails?.remit_to_zip_code || '',
      remitToState: !isAdmin && defaultRemitToState || null,
      remitToCountry: !isAdmin && defaultRemitToCountry || null,
      vendorTelephoneNumber: !isAdmin && editDetails?.vendor_telephone_number || '',
      vendorTelephoneExtension: !isAdmin && editDetails?.vendor_telephone_extension || '',
      vendorRepCellNumber: !isAdmin && editDetails?.vendor_rep_cell_number || '',
      vendorRepName: !isAdmin && editDetails?.vendor_rep_name || '',
      vendorOrderEmail: !isAdmin && editDetails?.main_order_email || '',
      vendorAccountingEmail: !isAdmin && editDetails?.secondary_accounting_email || '',
      vendorAccountingPhoneNumber: !isAdmin && editDetails?.secondary_accounting_phone || '',
      vendorWebsite: !isAdmin && editDetails?.website_url || '',
      vendorRemitToName: !isAdmin && editDetails?.remit_to_name || '',
      vendorNotes: !isAdmin && editDetails?.vendor_note || '',
      coiOnFile: !isAdmin && Number(editDetails?.coi_on_file || 0) === 1,
      vendorPaymentTerms: editDetails ? customerTypeData?.find(val => editDetails?.customerTypeId == val.id) || null : null,
      customerAccountNumber: !isAdmin && editDetails?.customer_account_number || '',
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors, setFieldError }) => {
      
      let team = {}
      try {
        if(!isAdmin) {
          values.address = values.address?.trim() || '';
          values.city = values.city?.trim() || '';
          values.zipcode = values.zipcode != null ? (String(values.zipcode).trim() || '') : '';
        }
        if(!isAdmin && (popupOn ? clientType === 'vendor' : clientId.type === 'vendor')) {
          values.remitToAddress = cleanTextValue(values.remitToAddress) || null;
          values.remitToCity = cleanTextValue(values.remitToCity) || null;
          values.remitToZipCode = values.remitToZipCode != null ? (String(values.remitToZipCode).trim() || null) : null;
          values.remitToState = values.remitToState || null;
          values.vendorTelephoneNumber = cleanTextValue(values.vendorTelephoneNumber);
          values.vendorTelephoneExtension = cleanTextValue(values.vendorTelephoneExtension);
          values.vendorRepCellNumber = cleanTextValue(values.vendorRepCellNumber);
          values.vendorRepName = cleanTextValue(values.vendorRepName);
          values.vendorOrderEmail = cleanTextValue(values.vendorOrderEmail);
          values.vendorAccountingEmail = cleanTextValue(values.vendorAccountingEmail);
          values.vendorAccountingPhoneNumber = cleanTextValue(values.vendorAccountingPhoneNumber);
          values.vendorWebsite = cleanTextValue(values.vendorWebsite);
          values.vendorRemitToName = cleanTextValue(values.vendorRemitToName);
          values.vendorNotes = cleanTextValue(values.vendorNotes);
          values.customerAccountNumber = cleanTextValue(values.customerAccountNumber);
        }
        console.log("success 1")

if((popupOn ? clientType === 'client' : clientId.type === 'client') && !values.customerType){
  return enqueueSnackbar("Payment Terms is required", { variant: 'error' })
}
        if(values.isSyncWithQuickbooks===true){
          if(!values.quickbookCustomerName){
            {(popupOn && clientType === 'client') || (!popupOn && clientId.type === 'client') ?
            enqueueSnackbar("customer display name is required", { variant: 'error' })
            :
            enqueueSnackbar("Vendor display name is required", { variant: 'error' })
            }
            return
          }
        
          if(!uniqueName) {
            (popupOn && clientType === 'client') || (!popupOn && clientId.type === 'client')?
            enqueueSnackbar("Existing customer display name in Quickbooks", { variant: 'error' })
            :
            enqueueSnackbar("Existing Vendor display name in Quickbooks", { variant: 'error' })
            return
          }
        }


        if (isAdmin ||userType ==3) {
          console.log("success 2")

        
            if(!values.email && !values.phoneNumber) {
              return  enqueueSnackbar("Email or Phone number is required", { variant: 'error' });
            }
            else if(values.phoneNumber && !values.forward_no && userType !==3){
              return  enqueueSnackbar("Forward number is required", { variant: 'error' });
            }
    
          try {
            /*****************UPDATE IN STAFF MEMBER TABLE************************************************************/
            if(newPassword !== confirmPassword){
              setConfirmPassError('Passwords do not match');
            }else{
              if (await blockIfCredentialDuplicate(values, setFieldError, setSubmitting)) return;
              if(values.forward_no ||userType ==3){
          console.log("success 3")

                if(true){ // if(values.hourlyRate || userType ==3){
                  team['first_name'] = values.name
                  team['last_name'] = values.lastName
                  team['email'] = values.email
                  team['forward_no'] = values.forward_no
                  team['forward_country_code'] = values.forward_country_code
                  team['hourly_rate'] = values.hourlyRate
                  if (values.phoneNumber) {
                    team['phone'] = values.phoneNumber
                    team['phone_country_code'] = values.phone_country_code
                  }
                  team['phone_extension'] = values.phone_extension;
                  if (values.city) {
                    team['city'] = values.city
                  }
                  if (values.state) {
                    team['state_id'] = values.state.id
                  }
                  if (values.service){
                    const idsString = values.service?.filter(obj => obj && obj.id)?.map(obj => obj.id).join(',');
                    team['services'] = idsString
                  }
                  if (values?.contact_tags){
                    const ids = values.contact_tags?.filter(obj => obj && obj.id)?.map(obj => obj.id).join(',');
                    team['contact_tags'] = ids
                  }
                  if(!editId || editId==""){
                    console.log('editId not available')
                    return;
                  }
                  if(confirmPassword){
                    team['password'] = confirmPassword
                  }
            
                  const updatedTeam = await axios.post(`${REST_API_END_POINT}teams/update-team`,{ editId, team },
                    {
                      headers: { 'Content-Type': 'application/json' },
                    },
                  )

                  const statusData = updatedTeam.data.status
                  
                  /****************UPDATE IN USER TABLE***********************************************************************/
                  let role, department;
                  if (values.role) {
                    role = values.role.id
                  }
                  if (values.department) {
                    department = values.department.id
                  }

                  if(statusData === 1){
                    const formData = new FormData()
                    formData.append('profile_pic', values.profile_pic)
                    formData.append('company_logo', values.avatarUrl)
                    formData.append('first_name', values.name)
                    formData.append('last_name', values.lastName)
                    formData.append('email', values.email)
                    formData.append('password', newPassword)
                    formData.append('user_type', role)
                    formData.append('department_id', department)
                    formData.append('statusData', statusData)
                    formData.append('loggedInUserId', userData.user_id)
                    formData.append('loggedInUserType', userData.user_type)
                    //Displaying formdata in console
                    //----------------------------------------
                    
                    // for (var pair of formData.entries()) {
                    //   console.log(pair[0] + ' - ' + pair[1])
                    // }
                    const updatedUser = await axios.post(
                      `${REST_API_END_POINT}teams/update-user?userId=${editDetails.user_id}`,
                      formData,
                      {
                        headers: { 'Content-Type': 'multipart/form-data' },
                      },
                    )
                    const updatedUserStatus = updatedUser.data.status
                    if (statusData === 1 && updatedUserStatus === 1) {
                      enqueueSnackbar(updatedUser.data.message, { variant: 'success' })
                    } else {
                      enqueueSnackbar(updatedUser.data.message || updatedTeam?.data?.message, { variant: 'error' })
                    }
                    resetForm()
                    setSubmitting(false)
                    navigate(PATH_DASHBOARD.callCenter.teams)
                  }else{
                    enqueueSnackbar(updatedTeam?.data?.message, { variant: 'error' })
                  }
                }
                // else{
                //   setFieldError('hourlyRate','Hourly rate is required')
                // }
              }else{
                setFieldError('forward_no','Forward number is required')
              }
            }
          } catch (error) {
            console.log('Error in updation : ', error)
            enqueueSnackbar('Error in updation', { variant: 'error' })
          }
        } else {
          if(newPassword !== confirmPassword){
            setConfirmPassError('Passwords do not match');
          }else{
            if (await blockIfCredentialDuplicate(values, setFieldError, setSubmitting)) return;
            if(!editId || editId==""){
              console.log('editId not available')
              return;
            }
            console.log('avalaraTaxTypeavalaraTaxType',avalaraTaxType)
            if(avalaraTaxType && avalaraTaxType == '1'){
              console.log('Skipping uploadFiles check...')
            }else if((!uploadFiles || uploadFiles?.length <= 0) && (popupOn ? clientType === "client" : clientId.type === "client")){
              setFieldError('uploadFiles','Please upload tax-exempt documents')
              enqueueSnackbar('Please upload tax-exempt documents', { variant: 'error' })
              return;
            }

            // Validate additional emails
            const hasEmptyAdditionalEmail = values.additionalEmails.some(emailObj => !emailObj.email || emailObj.email.trim() === '');
            if (hasEmptyAdditionalEmail) {
              enqueueSnackbar('Please fill all additional email fields to submit the form', { variant: 'error' });
              return;
            }
            const data={
              clientId: editId,
              values: {
                ...values,
                additionalEmails: values.additionalEmails,
                uploadFiles,
                insuranceFiles,
                otherFormFiles
              },
              newPassword,
              userId: userData.user_id,
              isNewVendor
            }
            const res = await axios.post(`${REST_API_END_POINT}clients/update-client`,data)
          
            if(res.data.status ==1){
              resetForm()
              setSubmitting(false)
              enqueueSnackbar(res.data.message, {variant: 'success'})
              closeView()
              setRenderCards(!renderCards)
              // if(clientId.type === 'client'){
              //   navigate(PATH_DASHBOARD.client.cards)
              // }else {
              //   navigate(PATH_DASHBOARD.client.vendors)
              // }
            }else if(res.data.status ==0){
              resetForm()
              setSubmitting(false)
              enqueueSnackbar(res.data.message, {variant: 'success'})
              closeView()
              // if(clientId.type === 'client'){
              //   navigate(PATH_DASHBOARD.client.cards)
              // }else {
              //   navigate(PATH_DASHBOARD.client.vendors)
              // }
            }else {
              resetForm()
              setSubmitting(false)
              enqueueSnackbar('Failed to update profile', {variant: 'error'})
            }
          }
        }
      } catch (error) {
        console.error(error)
        setSubmitting(false)
        setErrors(error)
      }
    },
  })

  const {
    errors,
    values,
    touched,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    getFieldProps,
  } = formik

  const preventInvalidNumberInput = (event) => {
    const blockedKeys = ['e', 'E', '+', '-', '.', 'ArrowUp', 'ArrowDown'];
    if (blockedKeys.includes(event.key)) {
      event.preventDefault();
    }
  };

  // Auto-save confirmation dialog handlers
  const handleBackConfirmYes = async () => {
    setOpenBackConfirm(false);
    try {
      await formik.submitForm();
      // Navigation will happen in onSubmit success handler
    } catch (error) {
      console.error('Auto-save failed:', error);
      // Still navigate back on error
      if (isAdmin) {
        navigate(PATH_DASHBOARD.callCenter.teams);
      } else {
        if (popupOn) {
          closeView();
        } else {
          if (clientType === 'client') {
            navigate(PATH_DASHBOARD.client.cards);
          } else {
            navigate(PATH_DASHBOARD.client.vendors);
          }
        }
      }
    }
  };

  const handleBackConfirmNo = () => {
    setOpenBackConfirm(false);
    if (isAdmin) {
      navigate(PATH_DASHBOARD.callCenter.teams);
    } else {
      if (popupOn) {
        closeView();
      } else {
        if (clientType === 'client') {
          navigate(PATH_DASHBOARD.client.cards);
        } else {
          navigate(PATH_DASHBOARD.client.vendors);
        }
      }
    }
  };

  const [setAdd] = useState(false)
  //function to update the profile pic
console.log("values=============",values);

// const handleDropProfilePic = useCallback(
//   (acceptedFiles) => {
//   //   if(isAdmin){
//   //   let file = acceptedFiles[0]
//   //   if (file) {
//   //     setSelectedFile(file)
//   //     setFieldValue('profile_pic', {
//   //       ...file,
//   //       preview: URL.createObjectURL(file),
//   //     })
//   //   }
//   // }else{
//     const file = acceptedFiles[0]
//     if(file){
//       const Filename = new Date().getTime() + file.name;

//       const StorageRef = ref(storage, Filename);
//       const uploadTask = uploadBytesResumable(StorageRef, file);
//       uploadTask.on(
//         'state_changed',
//         (snapshot) => {
//           const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
//           setProgress(progress); 
//         },
//         (error) => {
//           console.error(error.message);
//         },
//         () => {
//           getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
//             setFieldValue('profile_pic', downloadURL);
//             console.log(downloadURL, '&&&&&&&&&&&&&&&&&&&');
//           });
//         }
//       );
//     }
//   },
//   [setFieldValue],
// )
///below functn to update the logo 
  // const handleDrop = useCallback(
  //   (acceptedFiles) => {
  //   //   if(isAdmin){
  //   //   let file = acceptedFiles[0]
  //   //   if (file) {
  //   //     setSelectedFile(file)
  //   //     setFieldValue('avatarUrl', {
  //   //       ...file,
  //   //       preview: URL.createObjectURL(file),
  //   //     })
  //   //   }
  //   // }else{
  //     const file = acceptedFiles[0]
  //     if(file){
  //       const Filename = new Date().getTime() + file.name;
    
  //       const StorageRef = ref(storage, Filename);
  //       const uploadTask = uploadBytesResumable(StorageRef, file);
  //       uploadTask.on(
  //         'state_changed',
  //         (snapshot) => {
  //           const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
  //           setProgress(progress); 
  //         },
  //         (error) => {
  //           console.error(error.message);
  //         },
  //         () => {
  //           getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
  //             setFieldValue('avatarUrl', downloadURL);
  //             console.log(downloadURL, '&&&&&&&&&&&&&&&&&&&');
  //           });
  //         }
  //       );
  //     }
  //   },
  //   [setFieldValue],
  // )

  const handleDropProfilePic = useCallback(
    async (acceptedFiles) => {
      const file = acceptedFiles?.[0];
      if (!file) return;
      if (file.size > 5 * 1024 * 1024) {
        enqueueSnackbar('Profile photo must be 5MB or smaller', { variant: 'error' });
        return;
      }

      const timestamp = Date.now();
      // This removes all #, %, &, + and other dangerous URL characters
const sanitizedName = file.name.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9.\-_]/g, '');;
      const fileName = `${timestamp}_${sanitizedName}`;

      const type = isAdmin ? 'team-member'
        : (popupOn ? clientType : clientId.type); // 'client' or 'vendor'

      const folder = type === 'vendor'
        ? 'vendor-images/profile-pics'
        : type === 'team-member'
          ? 'team-member-images/profile-pics'
          : 'client-images/profile-pics';

      const filePath = `${folder}/${fileName}`;

      try {
        const { error: uploadError } = await supabase.storage
          .from('signwise-attachments')
          .upload(filePath, file);

        if (uploadError) throw uploadError;

        const { data: publicUrlData, error: urlError } = supabase.storage
          .from('signwise-attachments')
          .getPublicUrl(filePath);

        if (urlError || !publicUrlData?.publicUrl) {
          throw new Error('Failed to get public URL');
        }

        setFieldValue('profile_pic', publicUrlData.publicUrl);
      } catch (err) {
        console.error('Upload Error:', err.message);
        enqueueSnackbar('Upload failed: ' + err.message, { variant: 'error' });
      }
    },
    [setFieldValue, isAdmin, popupOn, clientType, clientId]
  ); // supabase integration

  const handleDrop = useCallback(
    async (acceptedFiles) => {
      const file = acceptedFiles?.[0];
      if (!file) return;
      if (file.size > 5 * 1024 * 1024) {
        enqueueSnackbar('Cover image must be 5MB or smaller', { variant: 'error' });
        return;
      }

      const timestamp = Date.now();
      // This removes all #, %, &, + and other dangerous URL characters
const sanitizedName = file.name.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9.\-_]/g, '');;
      const fileName = `${timestamp}_${sanitizedName}`;

      const type = isAdmin ? 'team-member'
        : (popupOn ? clientType : clientId.type); // 'client' or 'vendor'

      const folder = type === 'vendor'
        ? 'vendor-images/cover-images'
        : type === 'team-member'
          ? 'team-member-images/cover-images'
          : 'client-images/cover-images';

      const filePath = `${folder}/${fileName}`;

      try {
        const { error: uploadError } = await supabase.storage
          .from('signwise-attachments')
          .upload(filePath, file);

        if (uploadError) throw uploadError;

        const { data: publicUrlData, error: urlError } = supabase.storage
          .from('signwise-attachments')
          .getPublicUrl(filePath);

        if (urlError || !publicUrlData?.publicUrl) {
          throw new Error('Failed to get public URL');
        }

        setFieldValue('avatarUrl', publicUrlData.publicUrl);
      } catch (err) {
        console.error('Upload Error:', err.message);
        enqueueSnackbar('Upload failed: ' + err.message, { variant: 'error' });
      }
    },
    [setFieldValue, isAdmin, popupOn, clientType, clientId]
  ); // supabase integration

  // useEffect(() => {
  //   if(editDetails?.quickbookCustomerName ===formik.values.quickbookCustomerName){
  //     console.log(editDetails?.quickbookCustomerName,formik.values.quickbookCustomerName,"vallllll");

  //    setUniqueName(true)
     
  //   }else{

    
  //   const customerExists = quickbookSandboxExistingCustomers?.some(customer => 
  //     customer.DisplayName === formik.values.quickbookCustomerName
  //   );
  //   console.log('quickbookCustomerName value:', formik.values.quickbookCustomerName);
  //   setUniqueName(true)
  //   console.log("customerExists",customerExists);
    
  //   if (customerExists) {
  //     console.log('Customer name already exists in QuickBooks');
  //     setUniqueName(false)
  //   }
  // }
  // }, [formik.values.quickbookCustomerName, quickbookSandboxExistingCustomers,editDetails]);

  const handleRemoveFile = (file, fieldName = 'uploadFiles') => {
    const setFilesByField = {
      uploadFiles: setUploadFiles,
      insuranceFiles: setInsuranceFiles,
      otherFormFiles: setOtherFormFiles,
    };
    const filesByField = {
      uploadFiles,
      insuranceFiles,
      otherFormFiles,
    };
    const currentFiles = filesByField[fieldName] || [];
    const updatedFiles = currentFiles.filter(f => f.url !== file.url);
    setFilesByField[fieldName]?.(updatedFiles);
    setFieldValue(fieldName, updatedFiles);
  };  
  
  const handleRemoveAllFiles = (fieldName = 'uploadFiles') => {
    const setFilesByField = {
      uploadFiles: setUploadFiles,
      insuranceFiles: setInsuranceFiles,
      otherFormFiles: setOtherFormFiles,
    };
    setFilesByField[fieldName]?.([]);
    setFieldValue(fieldName, []);
  };
  
  const handleFileDrop = useCallback(
    async (acceptedFiles, fieldName = 'uploadFiles', folderPath = 'clients/tax-exempt-documents') => {
      if (!acceptedFiles || acceptedFiles.length === 0) return;
      
      setIsUploadingFiles(true);
      
      try {
        const newFiles = [];
        for (const file of acceptedFiles) {
          const timestamp = Date.now();
          // This removes all #, %, &, + and other dangerous URL characters
const sanitizedName = file.name.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9.\-_]/g, '');;
          const fileName = `${timestamp}_${sanitizedName}`;
          const filePath = `${folderPath}/${fileName}`;
      
          // Upload the file to Supabase storage
          const { error: uploadError } = await supabase.storage
            .from('signwise-attachments')
            .upload(filePath, file);
      
          if (uploadError) throw uploadError;
      
          // Get public URL for the uploaded file
          const { data: publicUrlData, error: urlError } = supabase.storage
            .from('signwise-attachments')
            .getPublicUrl(filePath);
      
          if (urlError || !publicUrlData?.publicUrl) {
            throw new Error('Failed to generate public URL');
          }
      
          // Add file info to newFiles array
          newFiles.push({
            url: publicUrlData.publicUrl,
            file_type: file.type,
            extension: file.name.split('.').pop(),
            size: file.size
          });
        }
      
        const setFilesByField = {
          uploadFiles: setUploadFiles,
          insuranceFiles: setInsuranceFiles,
          otherFormFiles: setOtherFormFiles,
        };
        const filesByField = {
          uploadFiles,
          insuranceFiles,
          otherFormFiles,
        };
        const updatedFiles = [...(filesByField[fieldName] || []), ...newFiles];
        setFilesByField[fieldName]?.(updatedFiles);
        setProgress(100);
        setFieldValue(fieldName, updatedFiles);
      } catch (err) {
        console.error('Upload error:', err.message);
        enqueueSnackbar('Upload failed: ' + err.message, { variant: 'error' });
      } finally {
        setIsUploadingFiles(false);
        setProgress(null);
      }
    },
    [uploadFiles, insuranceFiles, otherFormFiles, setFieldValue, setIsUploadingFiles, setProgress]
  );  
  
  useEffect(() => {
    if(editDetails?.clientTaxExemptAttachments) {
      const attachmentFiles = editDetails.clientTaxExemptAttachments.map(attachment => ({
        url: attachment.url,
        file_type: attachment.file_type,
        extension: attachment.extension,
        size: attachment.size,
        attachment_type: attachment.attachment_type || 'tax_exempt'
      }));
      setUploadFiles(attachmentFiles.filter(file => file.attachment_type === 'tax_exempt'));
      setInsuranceFiles(attachmentFiles.filter(file => file.attachment_type === 'insurance'));
      setOtherFormFiles(attachmentFiles.filter(file => file.attachment_type === 'other_form'));
    }
  }, [editDetails]);

    // Function to add a new email field
  const handleAddEmail = () => {
    setFieldValue('additionalEmails', [...values.additionalEmails, { contact_name: '', email: '' }]);
  };

  // Function to handle deleting a specific email field
  const handleDeleteEmail = (index) => {
    const updatedEmails = [...values.additionalEmails];
    updatedEmails.splice(index, 1);
    setFieldValue('additionalEmails', updatedEmails);
  };

  // Function to handle the change in email input fields
  const handleEmailChange = (index, event) => {
    const updatedEmails = [...values.additionalEmails];
    updatedEmails[index].email = event.target.value;
    setFieldValue('additionalEmails', updatedEmails);
  };

  // Function to handle the change in contact name input fields
  const handleContactNameChange = (index, event) => {
    const updatedEmails = [...values.additionalEmails];
    updatedEmails[index].contact_name = event.target.value;
    setFieldValue('additionalEmails', updatedEmails);
  };

  useEffect(()=>{
    if(isNewVendor){
      setFieldValue('partnerQbId',null)
      setFieldValue('quickbookCustomerName',formik.values.name)
    }else{
      setFieldValue('partnerQbId',editDetails?.partnerQbId)
    }
  },[isNewVendor])

  return (
    <Page
      title={
        isAdmin
          ? `Edit Team-Member | ${COMPANY_NAME}`
          : `Edit ${(popupOn ? clientType === 'client' : clientId.type === 'client') ? 'Client' : 'Vendor'} | ${COMPANY_NAME}`
      }
    >
      <Container>
        <HeaderBreadcrumbs sx={{mt:3}}
          heading={isAdmin ? 'Edit Team Member' : ((popupOn ? clientType === 'client' : clientId.type === 'client' )? 'Edit Client' : 'Edit Vendors')}
        />
        {loading ?
                    <Stack
                    justifyContent="center"
                    alignItems="center"
                    sx={{ height: '100vh' }}
                  >
                    <CircularProgress color="primary" variant="indeterminate" />
                  </Stack>
                 :
          <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <Card sx={{ py: 10, px: 3 }}>
                  {/* {isEdit && (
                    <Label
                      color={values.status !== 'active' ? 'error' : 'success'}
                      sx={{
                        textTransform: 'uppercase',
                        position: 'absolute',
                        top: 24,
                        right: 24,
                      }}
                    >
                      {values.status}
                    </Label>
                  )} */}
                  <Box sx={{ mb: 5 }}>
                  <LabelStyle>Cover Image</LabelStyle>
                    <UploadAvatar
                      accept="image/*"
                      file={values.avatarUrl}
                      maxSize={5 * 1024 * 1024}
                      onDrop={handleDrop}
                      onDropRejected={() =>
                        enqueueSnackbar('Cover image must be 5MB or smaller', { variant: 'error' })
                      }
                      error={Boolean(touched.avatarUrl && errors.avatarUrl)}
                      // caption={
                      //   <Typography
                      //     variant="caption"
                      //     sx={{
                      //       mt: 2,
                      //       mx: 'auto',
                      //       display: 'block',
                      //       textAlign: 'center',
                      //       color: 'text.secondary',
                      //     }}
                      //   >
                      //     Allowed *.jpeg, *.jpg, *.png, *.gif
                      //     <br /> max size of {fData(5 * 1024 * 1024)}
                      //   </Typography>
                      // }
                    />
                    <FormHelperText error sx={{ px: 2, textAlign: 'center' }}>
                      {touched.avatarUrl && errors.avatarUrl}
                    </FormHelperText>
                  </Box>
                  <Box sx={{ mb: 5 }}>
                  <LabelStyle>Profile Photo</LabelStyle>
                    <UploadAvatar
                      accept="image/*"
                      file={values.profile_pic}
                      maxSize={5 * 1024 * 1024}
                      onDrop={handleDropProfilePic}
                      onDropRejected={() =>
                        enqueueSnackbar('Profile photo must be 5MB or smaller', { variant: 'error' })
                      }
                      error={Boolean(touched.profile_pic && errors.profile_pic)}
                      caption={
                        <Typography
                          variant="caption"
                          sx={{
                            mt: 2,
                            mx: 'auto',
                            display: 'block',
                            textAlign: 'center',
                            color: 'text.secondary',
                          }}
                        >
                          Allowed *.jpeg, *.jpg, *.png, *.gif
                          <br /> max size of {fData(5 * 1024 * 1024)}
                        </Typography>
                      }
                    />
                    <FormHelperText error sx={{ px: 2, textAlign: 'center' }}>
                      {touched.profile_pic && errors.profile_pic}
                    </FormHelperText>
                  </Box>
                  {/* {isEdit && (
                <FormControlLabel
                  labelPlacement="start"
                  control={
                    <Switch
                      onChange={(event) => setFieldValue('status', event.target.checked ? 'banned' : 'active')}
                      checked={values.status !== 'active'}
                    />
                  }
                  label={
                    <>
                      <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                        Banned
                      </Typography>
                      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        Apply disable account
                      </Typography>
                    </>
                  }
                  sx={{ mx: 0, mb: 3, width: 1, justifyContent: 'space-between' }}
                />
              )} */}
                </Card>
              </Grid>

              <Grid item xs={12} md={8}>
                <Card sx={{ p: 3 }}>
                  <Stack spacing={3}>
                    <Stack
                      direction={{ xs: 'column', sm: 'row' }}
                      spacing={{ xs: 3, sm: 2 }}
                    >
                      <TextField
                        fullWidth
                        label={isAdmin ? 'First Name' : (popupOn ? clientType === 'client' : clientId.type === 'client') ? 'Company Name' : 'Name/Company'}
                        {...getFieldProps('name')}
                        error={Boolean(touched.name && errors.name)}
                        helperText={touched.name && errors.name}
                      />
                      <TextField
                        fullWidth
                        label="Email" required
                        {...getFieldProps('email')}
                        error={Boolean(touched.email && errors.email)}
                        helperText={touched.email && errors.email}
                      />
                    </Stack>

                    {isAdmin && (
                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                        <TextField
                          fullWidth
                          label="Employee ID#"
                          value={editDetails?.id || editId || ''}
                          disabled
                        />
                      </Stack>
                    )}

                    {!isAdmin && (popupOn ? clientType === 'client' : clientId.type === 'client') && (
                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                        <TextField
                          fullWidth
                          label="Contact Name"
                          {...getFieldProps('contact_name')}
                          error={Boolean(touched.contact_name && errors.contact_name)}
                          helperText={touched.contact_name && errors.contact_name}
                        />
                      </Stack>
                    )}
                    {
                      isAdmin ? null :
                    <Stack spacing={2} sx={{ flex: 1 }}>
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <Typography variant="body2" color={!isNewVendor ? 'text.primary' : 'text.secondary'}>
                          {(popupOn ? clientType === 'client' : clientId.type === 'client') ? 'Existing Customer' : 'Existing Vendor'}
                        </Typography>
                        <Switch
                          checked={isNewVendor}
                          // onChange={(e) => setNewVendor(e.target.checked)}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setNewVendor(checked);
                            // Clear QuickBooks customer name only when toggling off
                            if (!checked) {
                              setFieldValue('quickbookCustomerName', null);
                              setSearchQuery('');
                            }
                          }}
                          color="primary"
                        />
                        <Typography variant="body2" color={isNewVendor ? 'text.primary' : 'text.secondary'}>
                          {(popupOn ? clientType === 'client' : clientId.type === 'client') ? 'New Customer' : 'New Vendor'}
                        </Typography>
                      </Stack>
                      {isNewVendor ? (
                        <TextField
                          fullWidth
                          label={(popupOn ? clientType === 'client' : clientId.type === 'client') ? 'Customer display name' : 'Vendor display name'}
                          placeholder="Name must be unique for every users"
                          {...getFieldProps('quickbookCustomerName')}
                          error={Boolean(touched.quickbookCustomerName && errors.quickbookCustomerName)}
                          helperText={touched.quickbookCustomerName && errors.quickbookCustomerName}
                        />
                      ) : (
                        <Autocomplete
                          fullWidth
                          options={vendorsOrCustomers.filter((option) => {
                            if (!option?.Id) return true;
                            const idStr = String(option.Id);
                            if (editDetails?.partnerQbId && String(editDetails.partnerQbId) === idStr) {
                              return true;
                            }
                            return !partnerQbIds.some((p) => String(p.partnerQbId) === idStr);
                          })}
                          loading={loadingVendorsOrCustomers}
                          getOptionLabel={(option) => (typeof option === 'string' ? option : option?.DisplayName || option?.name || '')}
                          value={values.quickbookCustomerName || null}
                          onChange={(e, newValue) => {
                            setFieldValue('quickbookCustomerName', newValue?.DisplayName || newValue?.name || newValue || '');
                            setFieldValue('partnerQbId', newValue?.Id || null);
                            if(newValue){
                              setFieldValue('name', newValue?.DisplayName || newValue?.name || newValue);
                            }
                          }}
                          onInputChange={(e, newInputValue) => {
                            setFieldValue('quickbookCustomerName', newInputValue);
                            setSearchQuery(newInputValue);
                          }}
                          renderOption={(props, option) => (
                            <li {...props}>
                              <img src={quickbookLogo} width="40px" height="20px" style={{ marginRight: 8 }} />
                              <span>
                                {typeof option === 'string'
                                  ? option
                                  : option?.DisplayName || option?.name || ''}
                              </span>
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={(popupOn ? clientType === 'client' : clientId.type === 'client') ? 'Customer display name' : 'Vendor display name'}
                              placeholder="Search existing..."
                              error={Boolean(touched.quickbookCustomerName && errors.quickbookCustomerName)}
                              helperText={touched.quickbookCustomerName && errors.quickbookCustomerName}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {loadingVendorsOrCustomers ? <CircularProgress color="inherit" size={20} sx={{ mr: 1 }} /> : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />
                          )}
                        />
                      )}
                      {!uniqueName && (
                        <Typography sx={{ color: 'red', ml: 1 }}>
                          {(popupOn ? clientType === 'client' : clientId.type === 'client') ? 'Customer' : 'Vendor'} name already exists
                        </Typography>
                      )}
                    </Stack>
                    }
                      {(clientType === 'client') && (
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                          <Autocomplete
                            fullWidth
                            multiple
                            id="tags-filled"
                            options={(teamMembers || []).sort((a, b) => {
                              const nameA = `${a?.first_name || ''} ${a?.last_name || ''}`.trim();
                              const nameB = `${b?.first_name || ''} ${b?.last_name || ''}`.trim();
                              return alphanumericCompare(nameA, nameB);
                            })}
                            getOptionLabel={(option) => {
                              if (typeof option === 'string') {
                                return option;
                              }
                              const fullName = [option?.first_name, option?.last_name].filter(Boolean).join(' ');
                              const userRole = option?.userRole ? ` (${option?.userRole})` : '';  // Add userRole if available
                              return fullName + userRole || option?.name || '';
                            }}
                            value={values.salesRepNames}
                            onChange={(event, newValue) => {
                              setFieldValue('salesRepNames', newValue);
                            }}
                            renderTags={(value, getTagProps) =>
                              value.map((option, index) => (
                                <Chip
                                  key={option.id || index}
                                  label={[option?.first_name, option?.last_name].filter(Boolean).join(' ') || option?.name || ''}
                                  {...getTagProps({ index })}
                                />
                              ))
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Sales Rep Names"
                                placeholder="Select Sales Rep's"
                                error={Boolean(touched.salesRepNames && errors.salesRepNames)}
                                helperText={touched.salesRepNames && errors.salesRepNames}
                              />
                            )}
                          />
                        </Stack>
                      )}
                    {values.additionalEmails?.length > 0 &&
                    values.additionalEmails.map((email, index) => (
                      <Stack key={index} direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                        <TextField
                          type="text"
                          fullWidth
                          label={`Contact Name`}
                          value={email.contact_name}
                          onChange={(event) => handleContactNameChange(index, event)}
                        />
                        <TextField
                          type="email"
                          fullWidth
                          label={`Additional Emails`}
                          value={email.email}
                          onChange={(event) => handleEmailChange(index, event)}
                          error={Boolean(touched[`email_${index}`] && errors[`email_${index}`])}
                          helperText={touched[`email_${index}`] && errors[`email_${index}`]}
                        />
                        <IconButton
                          onClick={() => handleDeleteEmail(index)}
                          sx={{ mt: 1 }}
                        >
                          <Delete />
                        </IconButton>
                      </Stack>
                    ))}

                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button variant="outlined" startIcon={<Icon icon={plusFill} />} onClick={handleAddEmail}>Add Another Email</Button>
                </Box>

                    {isAdmin ? (
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 3, sm: 2 }}
                      >
                        <Box sx={{ width: '100%' }}>
                          <Typography variant="subtitle2" sx={{ mb: 1,display:{ xs: 'none', sm: 'flex' }, color: 'text.secondary' }}>
                            {'\u200B'}
                          </Typography>
                        <TextField
                          fullWidth
                          label="Last Name"
                          {...getFieldProps('lastName')}
                          error={Boolean(touched.lastName && errors.lastName)}
                          helperText={touched.lastName && errors.lastName}
                        />
                        </Box>
                      <PhoneNumberField
                          label="Phone Number"
                          value={`+${values.phone_country_code}${values.phoneNumber}`}
                          // disabled
                          onChange={(val, data) => {
                            // data will always be defined here when the user picks a country or types
                            const phoneWithPlus = val.startsWith('+') ? val : `+${val}`
                            const parsed = parsePhoneNumberFromString(phoneWithPlus);
                            if (parsed) {
                              setFieldValue('phone_country_code', parsed.countryCallingCode);
                              setFieldValue('phoneNumber',            parsed.nationalNumber);
                            }
                          }}
                          onBlur={() => formik.setFieldTouched('phoneNumber', true)}
                          error={errors.phoneNumber}
                          touched={touched.phoneNumber}
                        />
                        <Box sx={{ width: '100%' }}>
                          <Typography variant="subtitle2" sx={{ mb: 1,display:{ xs: 'none', sm: 'flex' }, color: 'text.secondary' }}>
                            {'\u200B'}
                          </Typography>
                          <TextField
                            fullWidth
                            label="Phone Extension"
                            {...getFieldProps('phone_extension')}
                            type="number"
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ min: 0, step: 1 }}
                            onKeyDown={preventInvalidNumberInput}
                            onChange={(event) => {
                              const sanitizedValue = event.target.value.replace(/\D/g, '');
                              setFieldValue('phone_extension', sanitizedValue === '' ? null : sanitizedValue);
                            }}
                            error={Boolean(touched.phone_extension && errors.phone_extension)}
                            helperText={touched.phone_extension && errors.phone_extension}
                          />
                        </Box>

                      </Stack>
                    ) : (
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 3, sm: 2 }}
                      >
                        {/* <TextField
                          fullWidth
                          required
                          label="Phone Number"
                          {...getFieldProps('phoneNumber')}
                          type='number'
                          onKeyPress={(event) => {
                            if (event.key === '-') {
                              event.preventDefault();
                            }
                            if (event.key === '.') {
                              event.preventDefault();
                            }
                          }}
                          error={Boolean(
                            touched.phoneNumber && errors.phoneNumber,
                          )}
                          helperText={touched.phoneNumber && errors.phoneNumber}
                        /> */}
                        <PhoneNumberField
                          label="Phone Number"
                          value={`+${values.phone_country_code}${values.phoneNumber}`}
                          // disabled
                          onChange={(val, data) => {
                            // data will always be defined here when the user picks a country or types
                            const phoneWithPlus = val.startsWith('+') ? val : `+${val}`
                            const parsed = parsePhoneNumberFromString(phoneWithPlus);
                            if (parsed) {
                              setFieldValue('phone_country_code', parsed.countryCallingCode);
                              setFieldValue('phoneNumber',            parsed.nationalNumber);
                            }
                          }}
                          onBlur={() => formik.setFieldTouched('phoneNumber', true)}
                          error={errors.phoneNumber}
                          touched={touched.phoneNumber}
                        />
                        {(isAdmin || (popupOn ? (clientType === 'client' || clientType === 'vendor') : (clientId.type === 'client' || clientId.type === 'vendor'))) && (
                          <Box sx={{ width: '100%' }}>
                            <Typography variant="subtitle2" sx={{ mb: 1, color: 'text.secondary' }}>
                              {'\u200B'}
                            </Typography>
                            <TextField
                              fullWidth
                              label="Phone Extension"
                              {...getFieldProps('phone_extension')}
                              type="number"
                              InputLabelProps={{ shrink: true }}
                              inputProps={{ min: 0, step: 1 }}
                              onKeyDown={preventInvalidNumberInput}
                              onChange={(event) => {
                                const sanitizedValue = event.target.value.replace(/\D/g, '');
                                setFieldValue('phone_extension', sanitizedValue === '' ? null : sanitizedValue);
                              }}
                              error={Boolean(touched.phone_extension && errors.phone_extension)}
                              helperText={touched.phone_extension && errors.phone_extension}
                            />
                          </Box>
                        )}
                        <Box sx={{ width: '100%' }}>
                        <Typography variant="subtitle2" sx={{ mb: 1, color: 'text.secondary' }}>
                            {'\u200B'}
                          </Typography>
                        <TextField
                          fullWidth
                          label="Fax Number"
                          {...getFieldProps('fax')}
                          type='number'
                          onKeyPress={(event) => {
                            if (event.key === '-') {
                              event.preventDefault();
                            }
                            if (event.key === '.') {
                              event.preventDefault();
                            }
                          }}
                          error={Boolean(touched.fax && errors.fax)}
                          helperText={touched.fax && errors.fax}
                        />
                        </Box>
                      </Stack>
                    )}
                    {isAdmin ? (
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 3, sm: 2 }}
                      >
                        {userType !==3 &&
                            <PhoneNumberField
                              label="Call Forward Number"
                              value={`+${values.forward_country_code}${values.forward_no}`}
                              // disabled
                              onChange={(val, data) => {
                                const phoneWithPlus = val.startsWith('+') ? val : `+${val}`
                                const parsed = parsePhoneNumberFromString(phoneWithPlus);
                                if (parsed) {
                                  setFieldValue('forward_country_code', parsed.countryCallingCode);
                                  setFieldValue('forward_no', parsed.nationalNumber);
                                }
                              }}
                              onBlur={() => formik.setFieldTouched('forward_no', true)}
                              error={errors.forward_no}
                              touched={touched.forward_no}
                            />

                    }
                    {/* {userType !==3 &&
                    <Box sx={{ width: '100%' }}>
                          <Typography variant="subtitle2" sx={{ mb: 1,display:{ xs: 'none', sm: 'flex' }, color: 'text.secondary' }}>
                            {'\u200B'}
                          </Typography>
                        <TextField
                          fullWidth
                          label="Hourly rate"
                          {...getFieldProps('hourlyRate')}
                          type='number'
                          onKeyPress={(event) => {
                            if (event.key === '-') {
                              event.preventDefault();
                            }
                          }}
                          error={Boolean(touched.hourlyRate && errors.hourlyRate)}
                          helperText={touched.hourlyRate && errors.hourlyRate}
                        />
                        </Box>
                        } */}
                      </Stack>
                    ) : null }
                    {isAdmin ? (
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 3, sm: 2 }}
                      >
                        <TextField
                          fullWidth
                          label="City"
                          {...getFieldProps('city')}
                          error={Boolean(touched.city && errors.city)}
                          helperText={touched.city && errors.city}
                        />
                        
                        <Autocomplete
                          select
                          fullWidth
                          id="state"
                          options={(stateData || []).sort((a, b) => 
                            alphanumericCompare(a?.name || '', b?.name || '')
                          )}
                          getOptionLabel={(option) => option.name}
                          defaultValue={defaultState}
                          value={values.state}
                          onChange={(event, newValue) =>
                            setFieldValue('state', newValue)
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="State"
                              placeholder="Select State"
                              fullWidth
                              SelectProps={{ native: true }}
                            />
                          )}
                        >
                          <option value="" />
                          {(stateData || []).sort((a, b) => 
                            alphanumericCompare(a?.name || '', b?.name || '')
                          ).map((option) => (
                            <option key={option.id} value={option.name}>
                              {option.name}
                            </option>
                          ))}
                        </Autocomplete>
                      </Stack>
                    ) : (popupOn ? clientType === 'vendor' : clientId.type === 'vendor') ? (
                      <Box sx={{ p: 3, mb: 3, border: (theme) => `1px solid ${theme.palette.grey[500_32]}`, borderRadius: 2 }}>
                        <Typography variant="h6" sx={{ mb: 3 }}>
                          Primary Address
                        </Typography>
                        <Stack spacing={3}>
                          <TextField
                            fullWidth
                            label="Address"
                            {...getFieldProps('address')}
                            error={Boolean(touched.address && errors.address)}
                            helperText={touched.address && errors.address}
                          />
                          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                            <TextField
                              fullWidth
                              label="City"
                              {...getFieldProps('city')}
                              error={Boolean(touched.city && errors.city)}
                              helperText={touched.city && errors.city}
                            />
                            <TextField
                              fullWidth
                              type='number'
                              label="Zip code"
                              {...getFieldProps('zipcode')}
                              error={Boolean(touched.zipcode && errors.zipcode)}
                              helperText={touched.zipcode && errors.zipcode}
                            />
                            <Autocomplete
                              select
                              fullWidth
                              id="state"
                              options={(stateData || []).sort((a, b) => 
                                alphanumericCompare(a?.name || '', b?.name || '')
                              )}
                              getOptionLabel={(option) => option.name}
                              defaultValue={defaultState}
                              value={values.state}
                              onChange={(event, newValue) =>
                                setFieldValue('state', newValue)
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="State" required
                                  error={Boolean(touched.state && errors.state)}
                                  helperText={touched.state && errors.state}
                                  placeholder="Select State"
                                  fullWidth
                                  SelectProps={{ native: true }}
                                />
                              )}
                            >
                              <option value="" />
                              {(stateData || []).sort((a, b) => 
                                alphanumericCompare(a?.name || '', b?.name || '')
                              ).map((option) => (
                                <option key={option.id} value={option.name}>
                                  {option.name}
                                </option>
                              ))}
                            </Autocomplete>
                          </Stack>
                        </Stack>
                      </Box>
                    ) : (
                      <>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                          <TextField
                            fullWidth
                            label="Address"
                            {...getFieldProps('address')}
                            error={Boolean(touched.address && errors.address)}
                            helperText={touched.address && errors.address}
                          />
                          <TextField
                            fullWidth
                            label="City"
                            {...getFieldProps('city')}
                            error={Boolean(touched.city && errors.city)}
                            helperText={touched.city && errors.city}
                          />
                          <TextField
                            fullWidth
                            type='number'
                            label={getPostalCodeLabel(values.country, stateData)}
                            {...getFieldProps('zipcode')}
                            error={Boolean(touched.zipcode && errors.zipcode)}
                            helperText={touched.zipcode && errors.zipcode}
                          />
                        </Stack>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                          <Autocomplete
                            fullWidth
                            id="country"
                            options={countryData}
                            getOptionLabel={(option) => option?.name || ''}
                            value={values.country}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                            onChange={(event, newValue) => {
                              setFieldValue('country', newValue);
                              setFieldValue('state', null);
                              setFieldValue('stateProvince', '');
                              fetchStatesByCountry(newValue?.id);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Country"
                                error={Boolean(touched.country && errors.country)}
                                helperText={touched.country && errors.country}
                              />
                            )}
                          />
                          {requiresStateDropdown(values.country, stateData) && (
                            <Autocomplete
                              fullWidth
                              id="state"
                              options={(stateData || []).sort((a, b) =>
                                alphanumericCompare(a?.name || '', b?.name || '')
                              )}
                              getOptionLabel={(option) => option.name}
                              value={values.state}
                              onChange={(event, newValue) =>
                                setFieldValue('state', newValue)
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="State" required
                                  error={Boolean(touched.state && errors.state)}
                                  helperText={touched.state && errors.state}
                                  placeholder="Select State"
                                  fullWidth
                                />
                              )}
                            />
                          )}
                          {requiresStateProvinceText(values.country, stateData) && (
                            <TextField
                              fullWidth
                              label="State / Province"
                              {...getFieldProps('stateProvince')}
                              error={Boolean(touched.stateProvince && errors.stateProvince)}
                              helperText={touched.stateProvince && errors.stateProvince}
                            />
                          )}
                        </Stack>
                      </>
                    )}

                    {!isAdmin && (popupOn ? clientType === 'vendor' : clientId.type === 'vendor') && (
                      <Box sx={{ p: 3, mb: 3, border: (theme) => `1px solid ${theme.palette.grey[500_32]}`, borderRadius: 2 }}>
                        <Typography variant="h6" sx={{ mb: 3 }}>
                          Remit-To Address
                        </Typography>
                        <Stack spacing={3}>
                          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                            <TextField
                              fullWidth
                              label="Remit-To Address"
                              {...getFieldProps('remitToAddress')}
                              error={Boolean(touched.remitToAddress && errors.remitToAddress)}
                              helperText={touched.remitToAddress && errors.remitToAddress}
                            />
                            <TextField
                              fullWidth
                              label="Remit-To City"
                              {...getFieldProps('remitToCity')}
                              error={Boolean(touched.remitToCity && errors.remitToCity)}
                              helperText={touched.remitToCity && errors.remitToCity}
                            />
                            <TextField
                              fullWidth
                              type='number'
                              label="Remit-To Zip Code"
                              {...getFieldProps('remitToZipCode')}
                              error={Boolean(touched.remitToZipCode && errors.remitToZipCode)}
                              helperText={touched.remitToZipCode && errors.remitToZipCode}
                              onKeyPress={(event) => {
                                if (event.key === '-') {
                                  event.preventDefault();
                                }
                                if (event.key === '.') {
                                  event.preventDefault();
                                }
                              }}
                              onKeyDown={(event) => {
                                if (event.key === '-' || event.key === 'ArrowDown') {
                                  event.preventDefault();
                                }
                              }}
                              onWheel={(event) => {
                                event.target.blur();
                                event.preventDefault();
                              }}
                              inputProps={{
                                min: 0,
                                onInput: (e) => {
                                  if (e.target.value < 0) {
                                    e.target.value = '';
                                  }
                                }
                              }}
                            />
                          </Stack>

                          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                            <Autocomplete
                              fullWidth
                              id="remitToState"
                              options={(stateData || []).sort((a, b) => 
                                alphanumericCompare(a?.name || '', b?.name || '')
                              )}
                              getOptionLabel={(option) => option?.name || ''}
                              value={values.remitToState}
                              isOptionEqualToValue={(option, value) => option?.id === value?.id}
                              onChange={(event, newValue) => {
                                setFieldValue('remitToState', newValue);
                                if (newValue) {
                                  const usCountry = countries.find(c => c.code === 'US');
                                  if (usCountry) {
                                    setFieldValue('remitToCountry', usCountry);
                                  }
                                } else {
                                  setFieldValue('remitToCountry', null);
                                }
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Remit-To State"
                                  error={Boolean(touched.remitToState && errors.remitToState)}
                                  helperText={touched.remitToState && errors.remitToState}
                                />
                              )}
                            />
                            <Autocomplete
                              fullWidth
                              id="remitToCountry"
                              options={countries}
                              getOptionLabel={(option) => option?.label || ''}
                              value={values.remitToCountry}
                              isOptionEqualToValue={(option, value) => option?.code === value?.code}
                              onChange={(event, newValue) => setFieldValue('remitToCountry', newValue)}
                              disabled
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Remit-To Country"
                                  error={Boolean(touched.remitToCountry && errors.remitToCountry)}
                                  helperText={touched.remitToCountry && errors.remitToCountry}
                                />
                              )}
                            />
                          </Stack>
                        </Stack>
                      </Box>
                    )}
                    {!isAdmin && (popupOn ? clientType === 'vendor' : clientId.type === 'vendor') && (
                      <Box sx={{ p: 3, mb: 3, border: (theme) => `1px solid ${theme.palette.grey[500_32]}`, borderRadius: 2 }}>
                        {/* <Typography variant="h6" sx={{ mb: 3 }}>
                          Vendor Maintenance
                        </Typography> */}
                        <Stack spacing={3}>
                          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                            <TextField
                              fullWidth
                              type="number"
                              label="Vendor Telephone Number"
                              {...getFieldProps('vendorTelephoneNumber')}
                              error={Boolean(touched.vendorTelephoneNumber && errors.vendorTelephoneNumber)}
                              helperText={touched.vendorTelephoneNumber && errors.vendorTelephoneNumber}
                              onKeyDown={(event) => {
                                if (['e', 'E', '+', '-', '.'].includes(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              onInput={restrictVendorPhoneInput}
                              inputProps={{ min: 0, maxLength: 15 }}
                            />
                            {/* <TextField
                              fullWidth
                              label="Phone Extension"
                              {...getFieldProps('vendorTelephoneExtension')}
                            /> */}
                          </Stack>
                          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                            <TextField
                              fullWidth
                              label="Vendor Rep Name"
                              {...getFieldProps('vendorRepName')}
                            />
                            <TextField
                              fullWidth
                              type="number"
                              label="Vendor Rep Cell Number"
                              {...getFieldProps('vendorRepCellNumber')}
                              error={Boolean(touched.vendorRepCellNumber && errors.vendorRepCellNumber)}
                              helperText={touched.vendorRepCellNumber && errors.vendorRepCellNumber}
                              onKeyDown={(event) => {
                                if (['e', 'E', '+', '-', '.'].includes(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              onInput={restrictVendorPhoneInput}
                              inputProps={{ min: 0, maxLength: 15 }}
                            />
                          </Stack>
                          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                            <TextField
                              fullWidth
                              type="email"
                              // label="Primary Email Address for Placing Orders"
                              label="Primary Email Address"
                              {...getFieldProps('vendorOrderEmail')}
                              error={Boolean(touched.vendorOrderEmail && errors.vendorOrderEmail)}
                              helperText={touched.vendorOrderEmail && errors.vendorOrderEmail}
                            />
                            <TextField
                              fullWidth
                              type="email"
                              // label="Secondary Email for Accounting Contact"
                              label="Secondary Email"
                              {...getFieldProps('vendorAccountingEmail')}
                              error={Boolean(touched.vendorAccountingEmail && errors.vendorAccountingEmail)}
                              helperText={touched.vendorAccountingEmail && errors.vendorAccountingEmail}
                            />
                          </Stack>
                          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                            <TextField
                              fullWidth
                              type="number"
                              // label="Secondary Telephone Number for Accounting Contact"
                              label="Secondary Telephone Number"
                              {...getFieldProps('vendorAccountingPhoneNumber')}
                              error={Boolean(touched.vendorAccountingPhoneNumber && errors.vendorAccountingPhoneNumber)}
                              helperText={touched.vendorAccountingPhoneNumber && errors.vendorAccountingPhoneNumber}
                              onKeyDown={(event) => {
                                if (['e', 'E', '+', '-', '.'].includes(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              onInput={restrictVendorPhoneInput}
                              inputProps={{ min: 0, maxLength: 15 }}
                            />
                            <TextField
                              fullWidth
                              label="Vendor Website"
                              {...getFieldProps('vendorWebsite')}
                              error={Boolean(touched.vendorWebsite && errors.vendorWebsite)}
                              helperText={touched.vendorWebsite && errors.vendorWebsite}
                            />
                          </Stack>
                          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                            <TextField
                              fullWidth
                              // label="Vendors Remit-To Name (Name to print on checks)"
                              label="Vendors Remit-To Name"
                              {...getFieldProps('vendorRemitToName')}
                            />
                            <TextField
                              fullWidth
                              label="Customer Account Number"
                              {...getFieldProps('customerAccountNumber')}
                            />
                          </Stack>
                          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                            <Autocomplete
                              fullWidth
                              id="vendorPaymentTerms"
                              options={(customerTypeData || []).sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))}
                              value={values.vendorPaymentTerms || null}
                              isOptionEqualToValue={(option, value) =>
                                (option?.id || option?._id || option?.name) === (value?.id || value?._id || value?.name)
                              }
                              onChange={(event, newValue) => setFieldValue('vendorPaymentTerms', newValue || null)}
                              getOptionLabel={getPaymentTermLabel}
                              renderOption={renderPaymentTermOption}
                              renderInput={(params) =>
                                renderPaymentTermInput({
                                  params,
                                  value: values.vendorPaymentTerms,
                                  placeholder: "Select Payment Terms",
                                  error: Boolean(touched.vendorPaymentTerms && errors.vendorPaymentTerms),
                                  helperText: touched.vendorPaymentTerms && errors.vendorPaymentTerms,
                                })
                              }
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={Boolean(values.coiOnFile)}
                                  onChange={(event) => setFieldValue('coiOnFile', event.target.checked)}
                                  name="coiOnFile"
                                />
                              }
                              label="COI on file"
                              sx={{ width: '100%', ml: 0 }}
                            />
                          </Stack>
                          <TextField
                          fullWidth
                          multiline
                          rows={4}
                          label="Notes"
                          {...getFieldProps('vendorNotes')}
                          error={Boolean(touched.vendorNotes && errors.vendorNotes)}
                          helperText={
                          touched.vendorNotes && errors.vendorNotes
                           ? errors.vendorNotes
                          : `${(values.vendorNotes || '').length}/100 characters`
                         }
                        inputProps={{
                      maxLength: 100
                          }}
                            />
                          <Box sx={{ width: '100%' }}>
                            <LabelStyleNew>Upload Insurances</LabelStyleNew>
                            <UploadMultiFile
                              showPreview
                              files={insuranceFiles}
                              accept={documentUploadAccept}
                              maxSize={1024 * 1024 * 1024}
                              multiple
                              onDrop={(acceptedFiles) =>
                                handleFileDrop(acceptedFiles, 'insuranceFiles', 'vendors/insurances')
                              }
                              onRemove={(file) => handleRemoveFile(file, 'insuranceFiles')}
                              onRemoveAll={() => handleRemoveAllFiles('insuranceFiles')}
                              isUploading={isUploadingFiles}
                              sx={{ mt: 1 }}
                            />
                          </Box>
                          <Box sx={{ width: '100%' }}>
                            <LabelStyleNew>Upload Other Forms</LabelStyleNew>
                            <UploadMultiFile
                              showPreview
                              files={otherFormFiles}
                              accept={documentUploadAccept}
                              maxSize={1024 * 1024 * 1024}
                              multiple
                              onDrop={(acceptedFiles) =>
                                handleFileDrop(acceptedFiles, 'otherFormFiles', 'vendors/other-forms')
                              }
                              onRemove={(file) => handleRemoveFile(file, 'otherFormFiles')}
                              onRemoveAll={() => handleRemoveAllFiles('otherFormFiles')}
                              isUploading={isUploadingFiles}
                              sx={{ mt: 1 }}
                            />
                          </Box>
                        </Stack>
                      </Box>
                    )}

                    {isAdmin ? (
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 3, sm: 2 }}
                      >
                        {(userType !==3 && !isClient) &&
                        
                       <Autocomplete
                          multiple
                          fullWidth
                          id="service"
                          options={(servicesData || []).sort((a, b) => 
                            alphanumericCompare(a?.name || '', b?.name || '')
                          )}
                          getOptionLabel={(option) => option?.name}
                          defaultValue={values?.service || []}  // Set the default value here
                          value={values?.service}
                          onChange={(event, newValue) => setFieldValue('service', newValue)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Skills and Services"
                              placeholder="Select Skills and Services"
                              fullWidth
                              SelectProps={{ native: true }}
                            />
                          )}
                        />
}
                      </Stack>
                    ): null}

                    {isAdmin ? (
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 3, sm: 2 }}
                      >

                        <Autocomplete
                          select
                          fullWidth
                          id="role"
                          options={(roleData || []).sort((a, b) => 
                            alphanumericCompare(a?.name || '', b?.name || '')
                          )}
                          getOptionLabel={(option) => option.name}
                          defaultValue={defaultRole}
                          disabled={isClient}
                          value={values.role}
                          onChange={(event, newValue) =>
                            setFieldValue('role', newValue)
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="User Role"
                              placeholder="Select User Role"
                              fullWidth
                              SelectProps={{ native: true }}
                            />
                          )}
                        >
                          <option value="" />
                          {(roleData || []).sort((a, b) => 
                            alphanumericCompare(a?.name || '', b?.name || '')
                          ).map((option) => (
                            <option key={option.id} value={option.name}>
                              {option.name}
                            </option>
                          ))}
                        </Autocomplete>


{
  (userType !==3 && !isClient) &&

                        <Autocomplete
                          multiple
                          fullWidth
                          id="combo-box-dem"
                          options={(contactTags || []).sort((a, b) => 
                            alphanumericCompare(a?.name || '', b?.name || '')
                          )}
                          value={values.contact_tags}
                          onChange={(event, newValue) => setFieldValue('contact_tags', newValue)}
                          renderOption={(props, tag) => {
                            return(
                              <MenuItem {...props}>
                              <TagChip
                                color={tag.color}
                                variant={tag.variant}
                                label={tag.name}
                                size={'small'}
                              />
                            </MenuItem>
                            )
                          }}
                          renderTags={(tags, getTagProps) =>
                            tags.map((tag, i) => (
                              <TagChip
                                key={i}
                                color={tag.color}
                                variant={tag.variant}
                                label={tag.name}
                                size={'small'}
                                {...getTagProps({ index: i })}
                              />
                            ))
                          }
                          renderInput={(params) => (
                            <TextField {...params} label="Contact Tags" />
                          )}
                          getOptionLabel={(option) => option.name}

                          />
                        }
                        {
  userType !==3 &&
                        <Autocomplete
                          select
                          fullWidth
                          id="department"
                          options={(departmentData || []).sort((a, b) => 
                            alphanumericCompare(a?.name || '', b?.name || '')
                          )}
                          getOptionLabel={(option) => option.name}
                          defaultValue={defaultDepartment}
                          value={values.department}
                          onChange={(event, newValue) =>
                            setFieldValue('department', newValue)
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Department"
                              placeholder="Select Department"
                              fullWidth
                              SelectProps={{ native: true }}
                            />
                          )}
                        >
                          <option value="" />
                          {(departmentData || []).sort((a, b) => 
                            alphanumericCompare(a?.name || '', b?.name || '')
                          ).map((option) => (
                            <option key={option.id} value={option.name}>
                              {option.name}
                            </option>
                          ))}
                        </Autocomplete>
}
                      </Stack>
                    ) : (
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 3, sm: 2 }}
                      >
                      
                       {/* {partnerType&& <Autocomplete
                          select 
                          fullWidth
                          id="partner-type-as-demo" 
                          options={(partnerType || []).sort((a, b) => 
                            alphanumericCompare(a?.name || '', b?.name || '')
                          )} 
                          getOptionLabel={(option) => option.name}
                          defaultValue={defaultParnterType}
                          value={values.partnerType}
                          onChange={(event, newValue) =>
                            setFieldValue('partnerType', newValue)
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Partner Type"
                              placeholder="Partner Type"
                              fullWidth 
                              SelectProps={{ native: true }}
                            >
                              <option value="" />
                              {(partnerType || []).sort((a, b) => 
                                alphanumericCompare(a?.name || '', b?.name || '')
                              ).map((option) => (
                                <option key={option.id} value={option.name}>
                                  {option.name}
                                </option>
                              ))}
                            </TextField>
                          )}
                        /> } */}
                         {(contactTags && clientType != 'vendor') &&  <Autocomplete
                          multiple
                          fullWidth
                          id="combo-box-demo"
                          options={(contactTags || []).sort((a, b) => 
                            alphanumericCompare(a?.name || '', b?.name || '')
                          )}
                          value={values.contact_tags}
                          onChange={(event, newValue) => setFieldValue('contact_tags', newValue)}
                          renderOption={(props, tag) => {
                            return(
                              <MenuItem {...props}>
                              <TagChip
                                color={tag.color}
                                variant={tag.variant}
                                label={tag.name}
                                size={'small'}
                              />
                            </MenuItem>
                            )
                          }}
                          renderTags={(tags, getTagProps) =>
                            tags.map((tag, i) => (
                              <TagChip
                                key={i}
                                color={tag.color}
                                variant={tag.variant}
                                label={tag.name}
                                size={'small'}
                                {...getTagProps({ index: i })}
                              />
                            ))
                          }
                          renderInput={(params) => (
                            <TextField {...params} label="Contact Tags" />
                          )}
                          getOptionLabel={(option) => option.name}

                          />}
                       {ranks && <Autocomplete
                          select 
                          fullWidth
                          id="ranks" 
                          options={(ranks || []).sort((a, b) => 
                            alphanumericCompare(a?.name || '', b?.name || '')
                          )} 
                          getOptionLabel={(option) => option?.name}
                          defaultValue={defaultRank}
                          value={values?.rank}
                          onChange={(event, newValue) =>
                            setFieldValue('rank', newValue)
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Rank"
                              placeholder="Rank"
                              fullWidth 
                              SelectProps={{ native: true }} 
                            >
                              <option value="" />
                              {(ranks || []).sort((a, b) => 
                                alphanumericCompare(a?.name || '', b?.name || '')
                              ).map((option) => (
                                <option key={option.id} value={option.name}>
                                  {option.name}
                                </option>
                              ))}
                            </TextField>
                          )}
                        />}
                      </Stack>
                    )}

                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 3, sm: 2 }}
                      >
                        <TextField
                                label="New Password"
                                value={newPassword}
                                type={showNewPassword ? 'text' : 'password'}
                                onChange={(e) => {
                                  setNewPassword(e.target.value)
                                  setNewPassError('')
                                }}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        edge="end"
                                        onClick={() =>
                                          setShowNewPassword((prev) => !prev)
                                        }
                                      >
                                        <Icon
                                          icon={
                                            showNewPassword
                                              ? eyeFill
                                              : eyeOffFill
                                          }
                                        />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                                error={Boolean(newPassError)}
                                helperText={newPassError}
                                sx={{ width: '100%' }}
                                autoComplete="new-password"
                              />
                              <TextField
                                label="Confirm New Password"
                                type={showConfirmPassword ? 'text' : 'password'}
                                value={confirmPassword}
                                onChange={(e) => {
                                  setConfirmPassword(e.target.value)
                                  setConfirmPassError('')
                                }}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        edge="end"
                                        onClick={() =>
                                          setShowConfirmPassword(
                                            (prev) => !prev,
                                          )
                                        }
                                      >
                                        <Icon
                                          icon={
                                            showConfirmPassword
                                              ? eyeFill
                                              : eyeOffFill
                                          }
                                        />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                                error={Boolean(confirmPassError)}
                                helperText={confirmPassError}
                                sx={{ width: '100%' }}
                                autoComplete="new-password"
                              />
                      </Stack>
                      {userPin && hasSwitchUserPinPermission && (
                        <Stack
                          direction={{ xs: 'column', sm: 'row' }}
                          spacing={{ xs: 3, sm: 2 }}
                        >
                          <TextField
                            fullWidth
                            label="User PIN"
                            value={userPin || ''}
                            InputProps={{
                              readOnly: true,
                              endAdornment: (
                                <InputAdornment position="end">
                                  <CopyToClipboard
                                    text={userPin || ''}
                                    onCopy={() => {
                                      if (userPin) {
                                        enqueueSnackbar('Copied', { variant: 'success' });
                                      }
                                    }}
                                  >
                                    <Tooltip title="Copy Clipboard">
                                      <IconButton>
                                        <Icon
                                          icon={copyFill}
                                          width={24}
                                          height={24}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  </CopyToClipboard>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    onClick={async () => {
                                      setIsUpdatingPin(true);
                                      try {
                                        const userId = editDetails?.user_id;
                                        if (userId) {
                                          const result = await axios.post(`${REST_API_END_POINT}update-user-pin`, { userId });
                                          if (result.data.status === 1) {
                                            setUserPin(result.data.pin);
                                            enqueueSnackbar(result.data.message || 'PIN updated successfully', { variant: 'success' });
                                          } else {
                                            enqueueSnackbar(result.data.message || 'Failed to update PIN', { variant: 'error' });
                                          }
                                        }
                                      } catch (error) {
                                        console.error('Error updating PIN:', error);
                                        enqueueSnackbar(error.response?.data?.message || 'Failed to update PIN. Please try again', { variant: 'error' });
                                      } finally {
                                        setIsUpdatingPin(false);
                                      }
                                    }}
                                    disabled={isUpdatingPin}
                                    sx={{ boxShadow: 'none', ml: 1 }}
                                    startIcon={isUpdatingPin ? <CircularProgress size={16} /> : <Refresh />}
                                  >
                                    {isUpdatingPin ? 'Updating...' : 'Update PIN'}
                                  </Button>
                                </InputAdornment>
                              ),
                            }}
                            helperText="Your unique 4-digit PIN for quick login"
                          />
                        </Stack>
                      )}
                      {isAdmin ? null :
                        <Stack
                          direction={{ xs: 'column', sm:'row' }}
                          spacing={{ xs: 3, sm: 2 }}
                        >
                       {
                        (popupOn ? clientType ==='client' :clientId.type === 'client')?
                        <Autocomplete
                        fullWidth
                    sx={{ width: 400 }}
                    id="partner-type"
                    options={(customerTypeData || []).sort((a, b) => 
                      alphanumericCompare(a?.name || '', b?.name || '')
                    )}
                    value={values?.customerType || null}
                    onChange={(event, newValue) => {
                      if(newValue){
                        setFieldValue('customerType', newValue)
                      }else{
                        setFieldValue('customerType', null)

                      }
                    }}
                    renderInput={(params) =>
                      renderPaymentTermInput({
                        params,
                        value: values?.customerType,
                      })
                    }
                    // getOptionLabel={(option) => option?.name}
                    getOptionLabel={getPaymentTermLabel}
                    renderOption={renderPaymentTermOption}

                  />
                        :
                         ""
                       }
                        </Stack>
                      }
                        {(isAdmin || clientType === 'vendor')? null :
                        <>
                        <Stack
                          direction={{ xs: 'column', sm:'row' }}
                          spacing={{ xs: 3, sm: 2 }}
                        >
                           <Autocomplete
                              select
                              fullWidth
                              id="role"
                              options={(userRoles || []).sort((a, b) => 
                                alphanumericCompare(a?.name || '', b?.name || '')
                              )}
                              value={values?.role}
                              defaultValue={defaultRole}
                              getOptionLabel={(state) => state.name}
                              onChange={(event, value) => {
                                if (value) {
                                  setFieldValue('role', value);
                                }
                                else{
                                  setFieldValue('role', '');
                                }
                              }}
                              renderInput={(params) => (
                                <TextField {...params} label="Select Client User Role"
                                  placeholder="Type to search User Role"
                                  error={Boolean(touched.role && errors.role)}
                                  helperText={touched.role && errors.role}
                                />
                              )}
                            />
                          </Stack>

                          <>
                          <Typography variant="h6" sx={{  textAlign: 'right' }}>
                            Avalara Tax Type
                          </Typography>
                         <Stack direction="row" spacing={{ xs: 3, sm: 2 }} justifyContent="flex-end" alignItems="center">
                          <FormControl component="fieldset">
                            <RadioGroup
                              row
                              value={values.avalaraTaxType}
                              onChange={(event) => {
                                setFieldValue('avalaraTaxType', event.target.value)
                                setAvalaraTaxType(event.target.value)
                              }}
                            >
                              <FormControlLabel
                                value="1"
                                control={<Radio color="primary" />}
                                label="Taxable Client"
                              />
                              <FormControlLabel
                                value="2"
                                control={<Radio color="primary" />}
                                label="Tax-Exempt Client"
                              />
                            </RadioGroup>
                          </FormControl>
                       </Stack>
                          </>
                          </>
                      }
                      {
                        (popupOn ? clientType === "client" : clientId.type === "client") &&
                        values.avalaraTaxType === "2" && ( // Conditionally render based on avalaraTaxType
                          <Box sx={{ width: '100%', mt: 3 }}>
                            <LabelStyleNew>Upload Tax-Exempt Documents</LabelStyleNew>
                            <UploadMultiFile
                              showPreview
                              files={uploadFiles}
                              accept={documentUploadAccept}
                              maxSize={1024 * 1024 * 1024}
                              multiple={true}
                              onDrop={(acceptedFiles) =>
                                handleFileDrop(acceptedFiles, 'uploadFiles', 'clients/tax-exempt-documents')
                              }
                              onRemove={(file) => handleRemoveFile(file, 'uploadFiles')}
                              onRemoveAll={() => handleRemoveAllFiles('uploadFiles')}
                              isUploading={isUploadingFiles}
                              error={Boolean(touched.uploadFiles && errors.uploadFiles)}
                              helperText={touched.uploadFiles && errors.uploadFiles}
                              sx={{ mt: 1 }}
                            />

                          </Box>
                        )
                      }
                      <Box
                      sx={{
                        mt: 3,
                        display: 'flex',
                        justifyContent: 'flex-end',
                      }}
                    >
                      <LoadingButton
                        type="submit"
                        variant="contained"
                        loading={isSubmitting}
                      >
                        { 'Save Changes'}
                      </LoadingButton>
                      {isAdmin ? (
                        <Button
                          variant="outlined"
                          type="submit"
                          component={RouterLink}
                          to={PATH_DASHBOARD.callCenter.teams}
                          sx={{ marginLeft: '10px' }}
                        >
                          Cancel
                        </Button>
                      ) : (
                        <Button
                          variant="outlined"
                          type="submit"
                          onClick={() => {
                            if (popupOn) {
                              closeView(); 
                            } else {
                              if (clientType === 'client') {
                                navigate(PATH_DASHBOARD.client.cards);
                              } else {
                                navigate(PATH_DASHBOARD.client.vendors);
                              }
                            }
                          }}
                          
                          // component={RouterLink}
                          // to={clientId.type === 'client' ? PATH_DASHBOARD.client.cards : PATH_DASHBOARD.client.vendors} 
                          sx={{ marginLeft: '10px' }}
                        >
                          Cancel
                        </Button>
                      )}
                    </Box>
                  </Stack>
                </Card>
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>}

        {/* Auto-save confirmation dialog */}
        <Dialog
          open={openBackConfirm}
          onClose={() => setOpenBackConfirm(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Go back?</DialogTitle>
          <DialogContent>
            <Typography variant="body1">
              Do you want to auto save this {isAdmin ? 'team member' : (popupOn ? (clientType === 'client' ? 'client' : 'vendor') : (clientId.type === 'client' ? 'client' : 'vendor'))} before going back?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleBackConfirmNo} variant="outlined" color="primary">
              No, Go Back
            </Button>
            <Button onClick={handleBackConfirmYes} variant="contained" color="primary">
              Yes, Auto Save
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Page>
  )
}
